import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { TextAreaPresentationProps } from "@insite/mobius/TextArea/TextArea";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { css } from "styled-components";
import getProp from "@insite/mobius/utilities/getProp";
import SearchIcon from "@tCentro/Icons/SearchIcon";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import Hidden from "@insite/mobius/Hidden";
import Img from "@insite/mobius/Img";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Phone from "@insite/mobius/Icons/Phone";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import loadCentroConnectDataHandler from "@tCentro/Handlers/CENLoadCentroConnectDataHandler";
import searchCentroConnectHandler from "@tCentro/Handlers/CENSearchCentroConnectHandler";
import Clickable from "@insite/mobius/Clickable";
import { useState } from "react";
import { CENSMEDashboardDetailsModel } from "@tCentro/Services/CENSMEDashboardDetailsService";
import getCENSMEDashboardDetailsData from "@tCentro/Handlers/CENSMEDashboardDetailsHandler";
import getCENSMEAutoCompleteData from "@tCentro/Handlers/CENSMEAutoCompleteHandler";
import { CENSMEAutoCompleteModel, SMEEmployeeAutoComplete } from "@tCentro/Services/CENSMEAutoCompleteService";
import { SMEDetailsResponseModel, SMEDetailModel } from "@tCentro/Services/CENSMEDetailsService";
import getSMEDetailsData from "@tCentro/Handlers/CENSMEDetailsHandler";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import getSMESearchData, { SMESearchParameter } from "@tCentro/Handlers/CENSMESearchHandler";
import { SMESearchResultModel, SMESearchEmployeeResult } from "@tCentro/Services/CENSMESearchService";
import TechnicalIcon from "@tCentro/Icons/TechnicalIcon";
import PriceTagIcon from "@tCentro/Icons/PriceTagIcon";
import AvatarPlaceholder from "@tCentro/Icons/AvatarPlaceholder";
import ArrowLeftIcon from "@tCentro/Icons/ArrowLeftIcon";
import CloseIcon from "@tCentro/Icons/CloseIcon";
import ArrowLeftIconSME from "@tCentro/Icons/ArrowLeftIconSME";

const mapStateToProps = (state: ApplicationState) => ({
    coworkers: (state as any).t_centroConnect?.coworkers || [],
    expertiseCards: (state as any).t_centroConnect?.expertiseCards || [],
    searchResults: (state as any).t_centroConnect?.searchResults || null,
    isLoadingInitialData: (state as any).t_centroConnect?.isLoadingInitialData || false,
    isLoadingSearchResults: (state as any).t_centroConnect?.isLoadingSearchResults || false,
    session: getSession(state),
});

const mapDispatchToProps = {
    loadCentroConnectDataHandler,
    searchCentroConnectHandler,
    getCENSMEDashboardDetailsData,
    getCENSMEAutoCompleteData,
    getSMEDetailsData,
    getSMESearchData,
};

type props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

// ─── Style interface ─────────────────────────────────────────────────────────
export interface CENConnectSearchWidgetStyles {
    mainContainer: InjectableCss;
    header: TypographyProps;
    textAreaStyles?: TextAreaPresentationProps;
    searchInput?: TextFieldPresentationProps;
    headingContainer?: InjectableCss;
    searchesWrapper?: InjectableCss;
    searchTagStyles?: InjectableCss;
    searchWrapper?: InjectableCss;
    chipInputWrapper?: InjectableCss;
    chipBadge?: InjectableCss;
    chipClose?: InjectableCss;
    flyoutContainer?: InjectableCss;
    flyoutScrollBody?: InjectableCss;
    flyoutPeopleSection?: InjectableCss;
    flyoutSectionLabel?: InjectableCss;
    flyoutDivider?: InjectableCss;
    flyoutPeopleDivider?: InjectableCss;
    flyoutPersonRow?: InjectableCss;
    flyoutPersonLeft?: InjectableCss;
    flyoutPersonAvatar?: InjectableCss;
    flyoutPersonInfo?: InjectableCss;
    flyoutPersonName?: InjectableCss;
    flyoutPersonMeta?: InjectableCss;
    flyoutPersonTitle?: InjectableCss;
    flyoutPersonSeparator?: InjectableCss;
    flyoutPersonBranch?: InjectableCss;
    flyoutPersonExpertise?: InjectableCss;
    flyoutSectionBlock?: InjectableCss;
    flyoutSectionHeading?: InjectableCss;
    flyoutSectionLabelText?: InjectableCss;
    flyoutSectionSubtitle?: InjectableCss;
    flyoutSectionGrid?: InjectableCss;
    flyoutSectionGridCustom?: InjectableCss;
    flyoutSectionLink?: InjectableCss;
    flyoutFooter?: InjectableCss;
    flyoutFooterLink?: InjectableCss;
    mainContainerCo: InjectableCss;
    headingContainerCo: InjectableCss;
    headerCo: TypographyProps;
    textAreaStylesCo?: TextAreaPresentationProps;
    coworkerContainer?: InjectableCss;
    coworkerDiv?: InjectableCss;
    coworkerDivActive?: InjectableCss;
    detailDiv?: InjectableCss;
    detailDivCustom?: InjectableCss;
    tagsWrapper?: InjectableCss;
    tagsWrapperCustom?: InjectableCss;
    technicalIcon?: InjectableCss;
    priceTagIcon?: InjectableCss;
    coworkerAvatar?: InjectableCss;
    coworkerAvatarBorder?: InjectableCss;
    nameText?: InjectableCss;
    titleText?: InjectableCss;
    branchText?: InjectableCss;
    snippetText?: InjectableCss;
    titleBranchDiv?: InjectableCss;
    expertProfileWrapper?: InjectableCss;
    closeButtonWrapper?: InjectableCss;
    expertProfileHeader?: InjectableCss;
    expertProfileInfoWrapper: InjectableCss;
    expertProfileAvatar?: InjectableCss;
    expertProfileInfo?: InjectableCss;
    expertProfileName?: InjectableCss;
    expertProfileMeta?: InjectableCss;
    expertProfileActions?: InjectableCss;
    expertProfileActionsWithLink?: InjectableCss;
    expertProfilePhone?: InjectableCss;
    expertProfileEmailBtn?: ButtonPresentationProps;
    expertProfileSection?: InjectableCss;
    expertProfileSectionTitle?: InjectableCss;
    expertProfileAbout?: InjectableCss;
    expertProfileSectionTitleForExpertise?: InjectableCss;
    wrapExperties?: InjectableCss;
    expertProfileSectionAbout?: InjectableCss;
    expertProfileSectionTraining?: InjectableCss;
    expertProfileList?: InjectableCss;
    expertProfileBodyText?: InjectableCss;
    expertProfileTrainingItem?: InjectableCss;
    expertProfileTrainingInstitution?: InjectableCss;
    expertProfileTrainingDegree?: InjectableCss;
    expertProfileTrainingYears?: InjectableCss;
    phoneIconStyles?: IconPresentationProps;
    phoneNoStyles?: InjectableCss;
    phoneClickAble?: InjectableCss;
    mainContainerEx: InjectableCss;
    headingContainerEx: InjectableCss;
    headerEx: TypographyProps;
    textAreaStylesEx?: TextAreaPresentationProps;
    cardsContainer?: InjectableCss;
    cardStyle?: InjectableCss;
    cardImage?: InjectableCss;
    categoryWrapper?: InjectableCss;
    expertsImagesWrapper?: InjectableCss;
    expertAvatarSmall?: InjectableCss;
    categoryText?: InjectableCss;
    mainWrapperEc: InjectableCss;
    headerWrapper: InjectableCss;
    profileRow: InjectableCss;
    imageWrapper: InjectableCss;
    contentWrapper: InjectableCss;
    nameTextEc: InjectableCss;
    subText: InjectableCss;
    linkText: InjectableCss;
    buttonRow: InjectableCss;
    primaryButton: InjectableCss;
    secondaryButton: ButtonPresentationProps;
    sectionWrapper: InjectableCss;
    sectionTitle: InjectableCss;
    bodyText: InjectableCss;
    list: InjectableCss;
    detailsTextDiv?: InjectableCss;
    mainContainerNewSection: InjectableCss;
    headingContainerNewSection: InjectableCss;
    headerNewSection: TypographyProps;
    textAreaStylesNewSection?: TextAreaPresentationProps;
    coworkerContainerNewSection?: InjectableCss;
    coworkerDivNewSection?: InjectableCss;
    detailDivNewSection?: InjectableCss;
    nameTextNewSection?: InjectableCss;
    titleTextNewSection?: InjectableCss;
    branchTextNewSection?: InjectableCss;
    titleBranchDivNewSection?: InjectableCss;
    detailsTextDivNewSection?: InjectableCss;
    newSectionExpertImage?: InjectableCss;
    sectionSpinnerWrapper?: InjectableCss;
    sectionEmptyWrapper?: InjectableCss;
    resultSubHeadingText?: InjectableCss;
    resultValues?: InjectableCss;
    searchIconStyle?: IconPresentationProps;
    resultForGeneric?: InjectableCss;
    expertResultsWrapper?: InjectableCss;
    resultsForWrapper?: InjectableCss;
    resultHeadingWrapper?: InjectableCss;
    resultHeadingWrapperPeople?: InjectableCss;
    buttonsWrapper?: InjectableCss;
    closeBtnWrapeSpotlight?: InjectableCss;
    backBtnWrapper?: InjectableCss;
    leftArrowIcon?: InjectableCss;
}

// ─── Styles ──────────────────────────────────────────────────────────────────
export const cenConnectSearchWidgetStyles: CENConnectSearchWidgetStyles = {
    tagsWrapper: {
        css: css`
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            margin-top: 16px;
        `,
    },
    tagsWrapperCustom: {
        css: css`
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            margin-top: 0px;
        `,
    },
    technicalIcon: {
        css: css`
            background: #e6f0ff;
            color: #262525;
            font-size: 11px;
            font-weight: 600;
            padding: 3px 8px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            gap: 4px;
        `,
    },
    priceTagIcon: {
        css: css`
            background: #e6f7ec;
            color: #262525;
            font-size: 11px;
            font-weight: 600;
            padding: 3px 8px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            gap: 4px;
        `,
    },
    backBtnWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: 8px;
            margin-left: 64px;
            margin-top: 24px;
            cursor: pointer;
            width: fit-content;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 16px;
                    `,
                    css`
                        margin-left: 16px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    closeBtnWrapeSpotlight: {
        css: css`
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 32px 64px 0px;
            width: fit-content;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 16px;
                    `,
                    css`
                        padding-left: 16px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            gap: 16px;
            align-items: center;
        `,
    },
    resultHeadingWrapper: {
        css: css`
            margin-bottom: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 48px;
                    `,
                    css`
                        margin-bottom: 48px;
                    `,
                    css`
                        margin-bottom: 48px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    resultHeadingWrapperPeople: {
        css: css`
            margin-bottom: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 33px;
                    `,
                    css`
                        margin-bottom: 33px;
                    `,
                    css`
                        margin-bottom: 33px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    resultsForWrapper: {
        css: css`
            font-size: 32px;
            font-weight: 700;
            color: #262525;
            margin-bottom: 64px;
            display: inline-block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 48px;
                    `,
                    css`
                        margin-bottom: 48px;
                    `,
                    css`
                        margin-bottom: 48px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    expertResultsWrapper: {
        css: css`
            padding: 64px;
            padding-top: 24px;
            display: flex;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 45px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    resultForGeneric: {
        css: css`
            padding: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 45px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    searchIconStyle: {
        css: css`
            displya: flex;
            justify-content: center;
            align-items: center;
            svg {
                width: 18px;
                height: 18px;
            }
        `,
    },
    resultValues: {
        css: css`
            font-size: 18px;
            line-height: 24px;
            font-weight: 600;
            color: ${getColor("text.link")};
        `,
    },
    resultSubHeadingText: {
        css: css`
            font-size: 24px;
            line-height: 32px;
            font-weight: 600;
            color: #262525;
            margin-bottom: 24px;
            display: flex;
        `,
    },
    sectionSpinnerWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 48px 0;
            width: 100%;
        `,
    },
    sectionEmptyWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 48px 0;
            width: 100%;
            font-size: 14px;
            color: #9aa3b0;
            font-style: italic;
        `,
    },
    newSectionExpertImage: {
        css: css`
            width: 56px;
            height: 56px;
            border-radius: 50%;
            border: none;
            transform: scale(1.1);
            object-fit: cover;
        `,
    },
    mainContainerNewSection: {
        css: css`
            padding: 64px;
            display: flex;
            gap: 24px;
            flex-direction: column;
            max-width: 1800px;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                        padding-bottom: 0px;
                        padding-top: 48px;
                    `,
                    css`
                        padding: 16px;
                    `,
                    css`
                        padding: 45px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    headingContainerNewSection: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    headerNewSection: {
        css: css`
            font-size: 32px;
            line-height: 40px;
            font-weight: 700;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    textAreaStylesNewSection: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    coworkerContainerNewSection: {
        css: css`
            display: flex;
            gap: 24px;
            flex-wrap: wrap;
            max-width: 1800px;
            margin-left: auto;
            margin-right: auto;
            padding-bottom: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 16px;
                    `,
                    css`
                        flex-direction: column;
                        gap: 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    coworkerDivNewSection: {
        css: css`
            border: 2px solid #e0dfe0;
            display: flex;
            flex-direction: column;
            padding: 22px;
            flex: 0 0 calc(33.33% - 24px);
            gap: 8px;
            &:hover {
                border-color: #bdbbbd !important;
                box-shadow: 0 2px 12px rgba(0, 114, 206, 0.1);
            }
            cursor: pointer;
            transition:
                border-color 0.2s ease,
                box-shadow 0.2s ease;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex: 0 0 100%;
                    `,
                    css`
                        flex: 0 0 100%;
                    `,
                    css`
                        flex: 0 0 48%;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    detailDivNewSection: {
        css: css`
            display: flex;
            gap: 16px;
        `,
    },
    nameTextNewSection: {
        css: css`
            font-size: 18px;
            line-height: 24px;
            font-weight: 600;
            color: #262525;
        `,
    },
    titleBranchDivNewSection: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    titleTextNewSection: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
        `,
    },
    branchTextNewSection: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
        `,
    },
    detailsTextDivNewSection: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    detailsTextDiv: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    mainContainer: {
        css: css`
            padding: 64px;
            background-color: #f2f2f2;
            display: flex;
            gap: 48px;
            max-width: 1800px;
            margin-right: auto;
            margin-left: auto;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                        gap: 16px;
                    `,
                    css`
                        padding: 16px;
                        gap: 16px;
                    `,
                    css`
                        padding: 45px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    header: {
        css: css`
            font-size: 40px;
            line-height: 48px;
            font-weight: 800;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 32px;
                        line-height: 40px;
                    `,
                    css`
                        font-size: 32px;
                        line-height: 40px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    textAreaStyles: {
        css: css`
            font-size: 24px;
            line-height: 32px;
            font-weight: 600;
            color: #262525;
        `,
    },
    searchInput: {
        sizeVariant: "default",
        iconProps: {
            src: SearchIcon,
            css: css`
                width: 24px !important;
                height: 24px !important;
                padding: 0px !important;
                top: 12px !important;
                right: 20px !important;
                &:focus {
                    outline: none !important;
                }
            `,
        },
        border: "underline",
        cssOverrides: {
            formField: css`
                width: 100%;
                margin-top: 0;
                position: relative;
                button {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                button:focus {
                    outline: none !important;
                }
                button > span {
                    color: ${getProp("theme.typography.p.color")};
                    // top: 4px !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    top: 7px !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    top: 7px !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    top: 7px !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                input {
                    color: #636161 !important;
                    border: 2px solid #e0dfe0 !important;
                    border-radius: 24px !important;
                    background: ${COLORS.white} !important;
                    padding: 12px 24px !important;
                    height: 48px;
                    font-size: 14px !important;
                    line-height: 24px;
                    &::placeholder {
                        color: ${COLORS.background.tag};
                        opacity: 1;
                    }
                    &:-ms-input-placeholder {
                        color: ${COLORS.background.tag};
                    }
                    &::-ms-input-placeholder {
                        color: ${COLORS.background.tag};
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                &::placeholder {
                                    display: inline-block;
                                    max-width: 263px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            `,
                            css`
                                &::placeholder {
                                    display: inline-block;
                                    max-width: 263px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            `,
                            css``,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    headingContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css``,
                    css`
                        max-width: 66%;
                    `,
                    null,
                ])}
        `,
    },
    searchesWrapper: {
        css: css`
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            margin-top: 24px;
        `,
    },
    searchTagStyles: {
        css: css`
            padding: 8px 12px;
            border-radius: 64px;
            background-color: #ffffff;
            color: #0f96d9;
            font-size: 12px;
            line-height: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;
        `,
    },
    leftArrowIcon: {
        css: css`
            svg {
                path {
                    border: 2px solid red;
                    fill: #0f96d9 !important;
                }
            }
        `,
    },
    searchWrapper: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    chipInputWrapper: {
        css: css`
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            border: 2px solid #e0dfe0;
            border-radius: 24px;
            background: ${COLORS.white};
            height: 48px;
            box-sizing: border-box;
            padding: 0 48px 0 12px;
            cursor: text;
        `,
    },
    chipBadge: {
        css: css`
            display: inline-flex;
            align-items: center;
            background: ${COLORS.background.grayShade};
            color: #0f96d9;
            border-radius: 64px;
            padding: 4px 12px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            white-space: nowrap;
            max-width: calc(100% - 16px);
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 16px;
            gap: 4px;
        `,
    },
    chipClose: {
        css: css`
            padding: 5px;
            display: flex;
        `,
    },
    flyoutContainer: {
        css: css`
            position: absolute;
            left: 0;
            right: 0;
            background: #ffffff;
            border: 1px solid #e0dfe0;
            border-radius: 12px;
            box-shadow: 0px 8px 24px 0px rgba(38, 37, 37, 0.12);
            z-index: 1000;
            display: flex;
            flex-direction: column;
            max-height: 424px;
            overflow: hidden;
            margin-top: 4px;
        `,
    },
    flyoutScrollBody: {
        css: css`
            overflow-y: auto;
            flex: 1;
            padding: 24px;
            display: flex;
            flex-direction: column;
            gap: 32px;
            scrollbar-width: thin;
            scrollbar-color: #c9c8c8 transparent;
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: transparent;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #c9c8c8;
                border-radius: 3px;
            }
        `,
    },
    flyoutPeopleSection: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 0;
        `,
    },
    flyoutSectionLabel: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            color: #262525;
            text-transform: uppercase;
            margin-bottom: 4px;
        `,
    },
    flyoutDivider: {
        css: css`
            height: 1px;
            background: #e0dfe0;
        `,
    },
    flyoutPeopleDivider: {
        css: css`
            height: 1px;
            background: #e0dfe0;
        `,
    },
    flyoutPersonRow: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;
            cursor: pointer;
            @media (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
            }
            &:hover {
                background: #f7f7f7;
            }
        `,
    },
    flyoutPersonLeft: {
        css: css`
            display: flex;
            align-items: center;
            gap: 12px;
        `,
    },
    flyoutPersonAvatar: {
        css: css`
            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover;
                flex-shrink: 0;
            }
        `,
    },
    flyoutPersonInfo: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    flyoutPersonName: {
        css: css`
            font-size: 12px;
            font-weight: 600;
            color: ${COLORS.black};
            line-height: 16px;
        `,
    },
    flyoutPersonMeta: {
        css: css`
            display: flex;
            gap: 6px;
            align-items: center;
        `,
    },
    flyoutPersonTitle: {
        css: css`
            font-size: 12px;
            color: ${COLORS.background.tag};
            line-height: 16px;
            font-weight: 400px;
        `,
    },
    flyoutPersonSeparator: {
        css: css`
            font-size: 13px;
            color: #636161;
            line-height: 18px;
        `,
    },
    flyoutPersonBranch: {
        css: css`
            font-size: 12px;
            font-weight: 400;
            color: ${COLORS.background.tag};
            line-height: 16px;
        `,
    },
    flyoutPersonExpertise: {
        css: css`
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: ${COLORS.background.tag};
            font-style: italic;
            text-align: right;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 0;
            margin-left: 16px;
            @media (max-width: 768px) {
                margin-left: 52px;
                max-width: 221px;
                min-width: 0;
                display: block;
            }
        `,
    },
    flyoutSectionBlock: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    flyoutSectionHeading: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 4px;
        `,
    },
    flyoutSectionLabelText: {
        css: css`
            font-size: 16px;
            font-weight: 600;
            color: #262525;
            text-transform: uppercase;
        `,
    },
    flyoutSectionSubtitle: {
        css: css`
            font-size: 12px;
            color: #636161;
            font-weight: 400;
            line-height: 16px;
            font-style: italic;
        `,
    },

    flyoutSectionGrid: {
        css: css`
            display: grid;
            grid-template-columns: repeat(1, auto);
            column-gap: 16px;
            row-gap: 8px;
            justify-content: start;
            align-content: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(1, 1fr);
                    `,
                    css`
                        grid-template-columns: repeat(2, 1fr);
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    flyoutSectionLink: {
        css: css`
            font-size: 12px;
            color: ${getColor("text.link")};
            font-weight: 600;
            cursor: pointer;
            text-decoration: none;
            line-height: 16px;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    flyoutFooter: {
        css: css`
            padding: 0px 24px;
            padding-left: 0px;
            background: #ffffff;
            border-radius: 0 0 12px 12px;
            flex-shrink: 0;
        `,
    },
    flyoutFooterLink: {
        css: css`
            font-size: 12px;
            color: ${getColor("text.link")};
            cursor: pointer;
            line-height: 16px;
            font-weight: 600;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    mainContainerCo: {
        css: css`
            padding: 64px;
            display: flex;
            gap: 24px;
            flex-direction: column;
            padding-bottom: 0px;
            max-width: 1800px;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                        padding-bottom: 0px;
                    `,
                    css`
                        padding: 16px;
                        padding-bottom: 0px;
                    `,
                    css`
                        padding: 45px;
                        padding-bottom: 0px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    headingContainerCo: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    headerCo: {
        css: css`
            font-size: 32px;
            line-height: 40px;
            font-weight: 700;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    textAreaStylesCo: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    coworkerContainer: {
        css: css`
            display: flex;
            gap: 24px;
            flex-wrap: wrap;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 16px;
                    `,
                    css`
                        flex-direction: column;
                        gap: 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    coworkerDiv: {
        css: css`
            border: 2px solid #e0dfe0;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 22px;
            flex: 0 0 calc(33.333% - 20px);
            cursor: pointer;
            transition:
                border-color 0.2s ease,
                box-shadow 0.2s ease;
            &:hover {
                border-color: #bdbbbd !important;
                box-shadow: 0 2px 12px rgba(0, 114, 206, 0.1);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex: 0 0 100%;
                    `,
                    css`
                        flex: 0 0 100%;
                    `,
                    css`
                        flex: 0 0 48%;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    coworkerDivActive: {
        css: css`
            border: 2px solid ${getColor("text.link")};
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 24px;
            flex: 0 0 calc(33.333% - 20px);
            cursor: pointer;
            box-shadow: 0 2px 12px rgba(0, 114, 206, 0.15);
        `,
    },
    detailDiv: {
        css: css`
            display: flex;
            gap: 16px;
        `,
    },
    detailDivCustom: {
        css: css`
            display: flex;
        `,
    },
    coworkerAvatarBorder: {
        css: css`
            width: 56px;
            height: 56px;
            object-fit: contain;
            transform: scale(1.1);
            overflow: hidden;
            border-radius: 100%;
        `,
    },
    coworkerAvatar: {
        css: css`
            img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                border: none;
                transform: scale(1.1);
                object-fit: cover;
            }
        `,
    },
    nameText: {
        css: css`
            font-size: 18px;
            line-height: 24px;
            font-weight: 600;
            color: #262525;
        `,
    },
    titleBranchDiv: {
        css: css`
            display: flex;
            flex-direction: Column;
        `,
    },
    titleText: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
        `,
    },
    branchText: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
        `,
    },
    snippetText: {
        css: css`
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            color: #262525;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
    expertProfileWrapper: {
        css: css`
            background: #ffffff;
            display: flex;
            flex-direction: column;
            max-width: 1800px;
            margin: 0 auto;
        `,
    },
    closeButtonWrapper: {
        css: css`
            display: flex;
            width: 100%;
            margin-top: 20px;
            justify-content: flex-start;
            padding: 0px 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px 16px;
                    `,
                    css`
                        padding: 0px 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    expertProfileHeader: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 16px;
                    `,
                    css`
                        padding: 16px;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    expertProfileInfoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    expertProfileInfo: {
        css: css`
            display: flex;
            align-items: center;
            gap: 24px;
            flex: 1;
        `,
    },
    expertProfileAvatar: {
        css: css`
            img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                object-fit: cover;
            }
        `,
    },
    expertProfileName: {
        css: css`
            font-size: 32px;
            font-weight: 700;
            color: ${COLORS.black};
            line-height: 40px;
            @media (max-width: 768px) {
                font-size: 24px;
                font-weight: 600;
                line-height: 32px;
            }
        `,
    },
    expertProfileMeta: {
        css: css`
            font-size: 14px;
            color: #636161;
            line-height: 20px;
        `,
    },
    expertProfileActions: {
        css: css`
            display: flex;
            align-items: center;
            gap: 12px;
            flex-shrink: 0;
            @media (max-width: 768px) {
                gap: 8px;
            }
        `,
    },
    expertProfileActionsWithLink: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            flex-shrink: 0;
            @media (max-width: 768px) {
                gap: 8px;
            }
        `,
    },
    expertProfilePhone: {
        css: css`
            font-size: 14px;
            color: #262525;
            font-weight: 400;
            white-space: nowrap;
            display: flex;
        `,
    },
    expertProfileEmailBtn: {
        css: css`
            border-radius: 16px;
            padding: 8px 40px;
            font-size: 14px;
            font-weight: 600;
        `,
    },
    expertProfileSectionTraining: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 0px 64px;
            padding-bottom: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 24px 16px;
                    `,
                    css`
                        padding: 24px 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    expertProfileSectionAbout: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 64px;
            padding-top: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 24px 16px;
                    `,
                    css`
                        padding: 24px 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    expertProfileSection: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 0px 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 24px 16px;
                    `,
                    css`
                        padding: 24px 16px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    expertProfileSectionTitle: {
        css: css`
            font-size: 24px;
            font-weight: 600;
            color: ${COLORS.black};
            line-height: 32px;
        `,
    },
    expertProfileAbout: {
        css: css`
            font-size: 18px;
            color: ${COLORS.black};
            line-height: 28px !important;
            font-weight: 400;
        `,
    },

    expertProfileSectionTitleForExpertise: {
        css: css`
            font-size: 20px;
            font-weight: 600;
            color: ${COLORS.black};
            line-height: 32px;
            display: inline-block;
            margin-bottom: 12px;
        `,
    },
    wrapExperties: {
        css: css`
            display: flex;
            flexdirection: row;
            gap: 20px;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        `,
    },
    expertProfileList: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    expertProfileBodyText: {
        css: css`
            font-size: 18px;
            color: ${COLORS.black};
            line-height: 28px !important;
            font-weight: 400;
        `,
    },
    expertProfileTrainingItem: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 2px;
            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    expertProfileTrainingInstitution: {
        css: css`
            font-size: 18px;
            font-weight: 600;
            color: ${COLORS.black};
            line-height: 24px;
        `,
    },
    expertProfileTrainingDegree: {
        css: css`
            font-size: 18px;
            color: ${COLORS.black};
            line-height: 24px;
            font-weight: 400;
        `,
    },
    expertProfileTrainingYears: {
        css: css`
            font-size: 14px;
            color: #636161;
            line-height: 20px;
        `,
    },
    phoneIconStyles: {
        size: 24,
        css: css`
            svg {
                fill: ${getColor("primary")};
                stroke: ${getColor("primary")};
                ${({ theme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            fill: ${get(theme, "colors.info.contrast")};
                            stroke: none;
                        `,
                        css`
                            fill: ${get(theme, "colors.info.contrast")};
                            stroke: none;
                        `,
                        css`
                            fill: ${get(theme, "colors.info.contrast")};
                            stroke: none;
                        `,
                        css`
                            @media (min-width: 993px) and (max-width: 1079px) {
                                fill: ${get(theme, "colors.info.contrast")};
                                stroke: none;
                            }
                        `,
                    ])}
            }
        `,
    },
    phoneNoStyles: {
        css: css`
            color: ${getColor("primary")};
            line-height: 16px;
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-family: ${TYPOGRAPHY.fontFamily.title};
        `,
    },
    phoneClickAble: {
        css: css`
            color: ${getColor("primary")};
            gap: 2px;
        `,
    },
    mainContainerEx: {
        css: css`
            padding: 64px;
            padding-top: 0px;
            display: flex;
            gap: 24px;
            flex-direction: column;
            // padding-bottom: 0px;
            max-width: 1800px;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 16px;
                        padding-top: 48px;
                    `,
                    css`
                        padding: 16px;
                        padding-bottom: 0px;
                    `,
                    css`
                        padding: 45px;
                        padding-bottom: 0px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    headingContainerEx: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    headerEx: {
        css: css`
            font-size: 32px;
            line-height: 40px;
            font-weight: 700;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css`
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 600;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    textAreaStylesEx: {
        css: css`
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: #262525;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 400;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    cardsContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: start;
            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    cardStyle: {
        css: css`
            display: flex;
            flex-direction: column;
            overflow: hidden;
            width: calc(25% - 16px);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 48%;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    cardImage: {
        css: css`
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        `,
    },
    categoryWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 16px;
            background-color: #f2f2f2;
            align-items: center;
        `,
    },
    expertsImagesWrapper: {
        css: css`
            display: flex;
            & > *:not(:first-child) {
                margin-left: -8px;
            }
        `,
    },
    expertAvatarSmall: {
        css: css`
            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 2px solid #ffffff;
            }
        `,
    },
    categoryText: {
        css: css`
            font-size: 18px;
            line-height: 24px;
            font-weight: 600;
            color: #262525;
        `,
    },
    mainWrapperEc: {
        css: css`
            width: 375px;
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 16px 16px 64px 16px;
            background: #ffffff;
        `,
    },
    headerWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },
    profileRow: {
        css: css`
            display: flex;
            gap: 16px;
        `,
    },
    imageWrapper: {
        css: css`
            img {
                width: 104px;
                height: 104px;
                border-radius: 50%;
                object-fit: cover;
            }
        `,
    },
    contentWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 4px;
        `,
    },
    nameTextEc: {
        css: css`
            font-size: 18px;
            font-weight: 600;
        `,
    },
    subText: {
        css: css`
            font-size: 14px;
            color: #666;
        `,
    },
    linkText: {
        css: css`
            font-size: 14px;
            color: ${getColor("text.link")};
            text-decoration: underline;
        `,
    },
    buttonRow: {
        css: css`
            display: flex;
            gap: 12px;
        `,
    },
    primaryButton: {
        css: css`
            border-radius: 24px;
            padding: 6px 20px;
        `,
    },
    secondaryButton: {
        variant: "secondary",
        css: css`
            border-radius: 24px;
            padding: 6px 20px;
            background: white;
        `,
    },
    sectionWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    sectionTitle: {
        css: css`
            font-weight: 600;
            font-size: 16px;
        `,
    },
    bodyText: {
        css: css`
            font-size: 14px;
            color: #333;
        `,
    },
    list: {
        css: css`
            padding-left: 18px;
            font-size: 14px;
            color: #333;
            li {
                margin-bottom: 4px;
            }
        `,
    },
};

const styles = cenConnectSearchWidgetStyles;

const SectionSpinner: React.FC = () => (
    <StyledWrapper {...styles.sectionSpinnerWrapper}>
        <LoadingSpinner size={40} />
    </StyledWrapper>
);

const SectionEmpty: React.FC<{ message?: string }> = ({ message }) => (
    <StyledWrapper {...styles.sectionEmptyWrapper}>{message ?? translate("No data available.")}</StyledWrapper>
);

interface ExpertProfileViewProps {
    apiDetail: SMEDetailModel | null;
    isLoading: boolean;
    error: string | null;
    onClose: () => void;
    showAreasOfExpertise?: boolean;
}

const ExpertProfileView: React.FC<ExpertProfileViewProps> = ({
    apiDetail,
    isLoading,
    error,
    onClose,
    showAreasOfExpertise = true,
}) => {
    const [isProductTypesExpanded, setIsProductTypesExpanded] = React.useState(false);
    const [isBrandsExpanded, setIsBrandsExpanded] = React.useState(false);

    const MAX_ITEMS = 10;

    const productTypesExpertiseList = apiDetail?.productTypesExpertise ?? [];
    const brandsExpertiseList = apiDetail?.brandsExpertise ?? [];

    const visibleProductTypes = isProductTypesExpanded
        ? productTypesExpertiseList
        : productTypesExpertiseList.slice(0, MAX_ITEMS);

    const visibleBrands = isBrandsExpanded ? brandsExpertiseList : brandsExpertiseList.slice(0, MAX_ITEMS);

    return (
        <StyledWrapper {...styles.expertProfileWrapper}>
            <StyledWrapper {...styles.closeButtonWrapper}>
                <Button {...styles.expertProfileEmailBtn} variant="secondary" onClick={onClose}>
                    {translate("Back")}
                </Button>
            </StyledWrapper>

            {isLoading && <SectionSpinner />}

            {!isLoading && error && (
                <StyledWrapper style={{ padding: "32px 64px", color: "#dc2626", fontSize: 14 }}>{error}</StyledWrapper>
            )}

            {!isLoading && !error && apiDetail && (
                <>
                    <StyledWrapper {...styles.expertProfileHeader}>
                        <StyledWrapper {...styles.expertProfileInfo}>
                            <StyledWrapper {...styles.expertProfileAvatar}>
                                {apiDetail?.photoUrl &&
                                /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif|ico|tiff|tif|jfif)$/i.test(
                                    apiDetail.photoUrl,
                                ) ? (
                                    <Img src={`${origin}${apiDetail.photoUrl}`} />
                                ) : (
                                    <AvatarPlaceholder size={56} />
                                )}
                            </StyledWrapper>
                            <StyledWrapper {...styles.expertProfileInfoWrapper}>
                                <Typography {...styles.expertProfileName}>{apiDetail.name}</Typography>
                                <Typography {...styles.expertProfileMeta}>
                                    {`${apiDetail.title} | ${apiDetail.branchName}`}
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.expertProfileActions}>
                            <Hidden below="md">
                                <Clickable {...styles.phoneClickAble} href={`tel:${apiDetail.phone}`}>
                                    <Icon src={Phone} {...styles.phoneIconStyles} />
                                    <Typography as="span" {...styles.phoneNoStyles}>
                                        {apiDetail.phone}
                                    </Typography>
                                </Clickable>
                            </Hidden>
                            <Hidden above="sm">
                                <Clickable {...styles.phoneClickAble} href={`tel:${apiDetail.phone}`}>
                                    <Button {...styles.expertProfileEmailBtn} variant="primary">
                                        {translate("Call")}
                                    </Button>
                                </Clickable>
                            </Hidden>
                            {apiDetail?.isTextMessageAllowed && (
                                <Hidden above="sm">
                                    <Button
                                        {...styles.expertProfileEmailBtn}
                                        variant="secondary"
                                        onClick={() => {
                                            window.location.href = `sms:${apiDetail.phone}`;
                                        }}
                                    >
                                        {translate("Text")}
                                    </Button>
                                </Hidden>
                            )}

                            <Clickable href={`mailto:${apiDetail.email}`}>
                                <Button {...styles.expertProfileEmailBtn} variant="secondary">
                                    {translate("Email")}
                                </Button>
                            </Clickable>
                        </StyledWrapper>
                    </StyledWrapper>

                    {/* ── Areas of Expertise ── */}
                    {((apiDetail?.productTypesExpertise?.length ?? 0) > 0 ||
                        (apiDetail?.brandsExpertise?.length ?? 0) > 0) && (
                        <StyledWrapper {...styles.expertProfileSectionAbout}>
                            <Typography {...styles.expertProfileSectionTitle}>
                                {translate("Areas of Expertise")}
                            </Typography>

                            {(apiDetail?.productTypesExpertise?.length ?? 0) > 0 && (
                                <StyledWrapper>
                                    <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                        {translate("Product Categories")}
                                    </Typography>
                                    <StyledWrapper style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                        {visibleProductTypes.map((area, idx) => (
                                            <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                {/* Name */}
                                                <Typography {...styles.expertProfileBodyText}> {area.name}</Typography>

                                                {/* Tags */}
                                                {(area.isTechnicalSupport || area.isPriceAndAvailability) && (
                                                    <StyledWrapper {...styles.tagsWrapperCustom} as="span">
                                                        {area.isTechnicalSupport && (
                                                            <StyledWrapper {...styles.technicalIcon}>
                                                                <TechnicalIcon /> {translate("Technical Support")}
                                                            </StyledWrapper>
                                                        )}

                                                        {area.isPriceAndAvailability && (
                                                            <StyledWrapper {...styles.priceTagIcon}>
                                                                <PriceTagIcon /> {translate("Price & Availability")}
                                                            </StyledWrapper>
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                    {productTypesExpertiseList.length > MAX_ITEMS && (
                                        <StyledWrapper style={{ marginTop: "12px" }}>
                                            <Button
                                                variant="secondary"
                                                onClick={() => setIsProductTypesExpanded(!isProductTypesExpanded)}
                                            >
                                                {isProductTypesExpanded
                                                    ? translate("Show Less")
                                                    : translate("Show More")}
                                            </Button>
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            )}

                            {(apiDetail?.brandsExpertise?.length ?? 0) > 0 && (
                                <StyledWrapper>
                                    <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                        {translate("Brands")}
                                    </Typography>
                                    <StyledWrapper style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                        {visibleBrands.map((brand, idx) => (
                                            <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                {/* Name */}
                                                <Typography {...styles.expertProfileBodyText}>{brand.name}</Typography>

                                                {/* Tags */}
                                                {(brand.isTechnicalSupport || brand.isPriceAndAvailability) && (
                                                    <StyledWrapper {...styles.tagsWrapperCustom} as="span">
                                                        {brand.isTechnicalSupport && (
                                                            <StyledWrapper {...styles.technicalIcon}>
                                                                <TechnicalIcon /> {translate("Technical Support")}
                                                            </StyledWrapper>
                                                        )}

                                                        {brand.isPriceAndAvailability && (
                                                            <StyledWrapper {...styles.priceTagIcon}>
                                                                <PriceTagIcon /> {translate("Price & Availability")}
                                                            </StyledWrapper>
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                    {brandsExpertiseList.length > MAX_ITEMS && (
                                        <StyledWrapper style={{ marginTop: "12px" }}>
                                            <Button
                                                variant="secondary"
                                                onClick={() => setIsBrandsExpanded(!isBrandsExpanded)}
                                            >
                                                {isBrandsExpanded ? translate("Show Less") : translate("Show More")}
                                            </Button>
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}

                    {/* About */}
                    {apiDetail.bioFull && (
                        <StyledWrapper {...styles.expertProfileSectionAbout}>
                            <Typography {...styles.expertProfileSectionTitle}>{translate("About")}</Typography>
                            <Typography {...styles.expertProfileBodyText}>{apiDetail.bioFull}</Typography>
                        </StyledWrapper>
                    )}

                    {/* Training and Background */}
                    <StyledWrapper {...styles.expertProfileSectionTraining}>
                        <Typography {...styles.expertProfileSectionTitle}>
                            {translate("Training and Background")}
                        </Typography>
                        {apiDetail.education && (
                            <StyledWrapper {...styles.expertProfileTrainingItem}>
                                <Typography {...styles.expertProfileTrainingInstitution}>
                                    {translate("Education")}
                                </Typography>
                                <Typography {...styles.expertProfileTrainingDegree}>{apiDetail.education}</Typography>
                            </StyledWrapper>
                        )}
                        {apiDetail.trainingsAttended && (
                            <StyledWrapper {...styles.expertProfileTrainingItem}>
                                <Typography {...styles.expertProfileTrainingInstitution}>
                                    {translate("Trainings Attended")}
                                </Typography>
                                <Typography {...styles.expertProfileTrainingDegree}>
                                    {apiDetail.trainingsAttended}
                                </Typography>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </>
            )}

            {!isLoading && !error && !apiDetail && <SectionEmpty message={translate("Profile not available.")} />}
        </StyledWrapper>
    );
};
const CENSMEDirectoryWidget = (props: props) => {
    const {
        loadCentroConnectDataHandler,
        searchCentroConnectHandler,
        getCENSMEDashboardDetailsData,
        getCENSMEAutoCompleteData,
        getSMEDetailsData,
        getSMESearchData,
        session,
    } = props;

    // ── Search state ──────────────────────────────────────────────────────────
    const [inputValue, setInputValue] = React.useState("");
    const [chipValue, setChipValue] = React.useState<string | null>(null);
    const [isChipMode, setIsChipMode] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);
    const [isFlyoutVisible, setIsFlyoutVisible] = React.useState(false);
    const [autoCompleteData, setAutoCompleteData] = useState<CENSMEAutoCompleteModel | null>(null);
    const [selectedCoworkerIndex, setSelectedCoworkerIndex] = React.useState<number | null>(null);
    const [selectedNewTocentroIndex, setSelectedNewTocentroIndex] = React.useState<number | null>(null);
    const [smeDashboardData, setSmeDashboardData] = useState<CENSMEDashboardDetailsModel | null>(null);
    const [isDashboardLoading, setIsDashboardLoading] = useState(true);
    const [dashboardError, setDashboardError] = useState<string | null>(null);
    const coworkerList: any[] = smeDashboardData?.meetYourCoworker ?? [];
    const newToCentroList: any[] = smeDashboardData?.recentlyJoined ?? [];
    const expertiseSpotlightList: any[] = smeDashboardData?.expertiseSpotlight ?? [];
    // const [selectedSMEDetail, setSelectedSMEDetail] = useState<SMEDetailModel | null>(null);
    // const [isSMEDetailLoading, setIsSMEDetailLoading] = useState(false);
    // const [smeDetailError, setSMEDetailError] = useState<string | null>(null);
    const [coworkerSMEDetail, setCoworkerSMEDetail] = useState<SMEDetailModel | null>(null);
    const [isCoworkerSMEDetailLoading, setIsCoworkerSMEDetailLoading] = useState(false);
    const [coworkerSMEDetailError, setCoworkerSMEDetailError] = useState<string | null>(null);

    const [newToCentroSMEDetail, setNewToCentroSMEDetail] = useState<SMEDetailModel | null>(null);
    const [isNewToCentroSMEDetailLoading, setIsNewToCentroSMEDetailLoading] = useState(false);
    const [newToCentroSMEDetailError, setNewToCentroSMEDetailError] = useState<string | null>(null);
    // ── Search results page state ──────────────────────────────────────
    const [searchResultsData, setSearchResultsData] = useState<SMESearchResultModel | null>(null);
    const [isSearchResultsLoading, setIsSearchResultsLoading] = useState(false);
    const [searchResultsError, setSearchResultsError] = useState<string | null>(null);
    const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
    // ── Selected employee from search results ──────────────────────────
    const [searchSelectedEmployee, setSearchSelectedEmployee] = useState<SMESearchEmployeeResult | null>(null);
    const [searchEmployeeDetail, setSearchEmployeeDetail] = useState<SMEDetailModel | null>(null);
    const [isSearchEmployeeLoading, setIsSearchEmployeeLoading] = useState(false);
    const [currentExpertIndex, setCurrentExpertIndex] = useState<number>(0);
    const [searchMode, setSearchMode] = useState<"query" | "entity" | null>(null);
    const [lastSearchTerm, setLastSearchTerm] = useState<string>("");
    const [isSpotlightSearch, setIsSpotlightSearch] = useState<boolean>(false);
    const [isQuerySearchProductTypesExpanded, setIsQuerySearchProductTypesExpanded] = useState(false);
    const [isQuerySearchBrandsExpanded, setIsQuerySearchBrandsExpanded] = useState(false);
    const [isEntitySearchProductTypesExpanded, setIsEntitySearchProductTypesExpanded] = useState(false);
    const [isEntitySearchBrandsExpanded, setIsEntitySearchBrandsExpanded] = useState(false);

    // ── Resolve the expert list for entity searches ────────────────────
    const entityExpertList: SMESearchEmployeeResult[] =
        searchMode === "entity" ? (searchResultsData?.employeeSearchList ?? []) : [];
    const isEntitySearch = searchMode === "entity";

    const flyoutRef = React.useRef<HTMLDivElement>(null);
    const inputRef = React.useRef<HTMLInputElement>(null);
    const editingStartValueRef = React.useRef<string | null>(null);
    const debounceTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

    const fetchCoworkerDetail = (smeid: string) => {
        setCoworkerSMEDetail(null);
        setCoworkerSMEDetailError(null);
        setIsCoworkerSMEDetailLoading(true);
        getSMEDetailsData({
            smeid,
            onSuccess: (result: SMEDetailsResponseModel) => {
                setCoworkerSMEDetail(result.smeDetail);
                setIsCoworkerSMEDetailLoading(false);
            },
            onError: (error: string) => {
                setCoworkerSMEDetailError(error);
                setIsCoworkerSMEDetailLoading(false);
            },
        });
    };

    const fetchNewToCentroDetail = (smeid: string) => {
        setNewToCentroSMEDetail(null);
        setNewToCentroSMEDetailError(null);
        setIsNewToCentroSMEDetailLoading(true);
        getSMEDetailsData({
            smeid,
            onSuccess: (result: SMEDetailsResponseModel) => {
                setNewToCentroSMEDetail(result.smeDetail);
                setIsNewToCentroSMEDetailLoading(false);
            },
            onError: (error: string) => {
                setNewToCentroSMEDetailError(error);
                setIsNewToCentroSMEDetailLoading(false);
            },
        });
    };
    // ── Execute search by query string ────────────────────────────────
    const executeSearch = (query: string) => {
        const trimmed = (query ?? "").trim();
        if (trimmed.length < 3) return; // ← guard: minimum 3 chars

        setIsSpotlightSearch(false);
        setLastSearchTerm(trimmed);
        setIsSearchResultsLoading(true);
        setIsSearchResultsVisible(true);
        setSearchResultsError(null);
        setSearchSelectedEmployee(null);
        setSearchEmployeeDetail(null);
        setIsFlyoutVisible(false);
        setSearchMode("query");

        getSMESearchData({
            query: trimmed,
            onSuccess: (result: SMESearchResultModel) => {
                setSearchResultsData(result);
                setIsSearchResultsLoading(false);
            },
            onError: (error: string) => {
                setSearchResultsError(error);
                setIsSearchResultsLoading(false);
            },
        });
    };

    // ── Execute search by entity ID (category, brand, branch, employee) ──
    const executeEntitySearch = (id: string, entity: string, label?: string, fromSpotlight?: boolean) => {
        if (entity === "Employee") {
            setIsSearchResultsVisible(true);
            setIsSearchResultsLoading(false);
            setSearchResultsData(null);
            setSearchResultsError(null);
            setIsFlyoutVisible(false);
            setSearchMode("query");
            setIsSpotlightSearch(false);

            const placeholder: SMESearchEmployeeResult = {
                id,
                name: "",
                title: "",
                branchName: "",
            };
            setSearchSelectedEmployee(placeholder);
            setIsSearchEmployeeLoading(true);
            setSearchEmployeeDetail(null);

            getSMEDetailsData({
                smeid: id,
                onSuccess: (result: SMEDetailsResponseModel) => {
                    setSearchEmployeeDetail(result.smeDetail);
                    setIsSearchEmployeeLoading(false);
                    setSearchSelectedEmployee({
                        id,
                        name: result.smeDetail?.name ?? "",
                        fullName: result.smeDetail?.name ?? "",
                        title: result.smeDetail?.title ?? "",
                        branchName: result.smeDetail?.branchName ?? "",
                        photoUrl: result.smeDetail?.photoUrl ?? "",
                        email: result.smeDetail?.email,
                        phone: result.smeDetail?.phone,
                        productTypesExpertise: result.smeDetail?.productTypesExpertise, // ← add
                        brandsExpertise: result.smeDetail?.brandsExpertise,
                    });
                },
                onError: (error: string) => {
                    setIsSearchEmployeeLoading(false);
                    setSearchResultsError(error);
                    setSearchSelectedEmployee(null);
                },
            });
            return;
        }

        setIsSearchResultsLoading(true);
        setIsSearchResultsVisible(true);
        setSearchResultsError(null);
        setSearchSelectedEmployee(null);
        setSearchEmployeeDetail(null);
        setIsFlyoutVisible(false);
        setSearchMode("entity");
        setIsSpotlightSearch(!!fromSpotlight);
        if (label && label.trim()) {
            setLastSearchTerm(label.trim());
            if (!fromSpotlight) {
                commitChip(label.trim());
            }
        }

        getSMESearchData({
            id,
            entity,
            onSuccess: (result: SMESearchResultModel) => {
                setSearchResultsData(result);
                setIsSearchResultsLoading(false);
            },
            onError: (error: string) => {
                setSearchResultsError(error);
                setIsSearchResultsLoading(false);
            },
        });
    };

    // ── Handle clicking an employee card in search results ─────────────
    const handleSearchEmployeeClick = (employee: SMESearchEmployeeResult, index?: number) => {
        scrollToCensmeDirectoryWidget();
        if (!employee.id) {
            setSearchSelectedEmployee(employee);
            return;
        }

        setIsSearchEmployeeLoading(true);
        setSearchSelectedEmployee(employee);
        setSearchEmployeeDetail(null);
        // setIsSpotlightSearch(false);
        if (index !== undefined) setCurrentExpertIndex(index); // ← track index for prev/next

        getSMEDetailsData({
            smeid: employee.id,
            onSuccess: (result: SMEDetailsResponseModel) => {
                setSearchEmployeeDetail(result.smeDetail);
                setIsSearchEmployeeLoading(false);
            },
            onError: () => {
                setIsSearchEmployeeLoading(false);
            },
        });
    };

    const handleNavigateExpert = (direction: "prev" | "next") => {
        const list = entityExpertList;
        if (list.length === 0) return;

        const newIndex =
            direction === "next"
                ? (currentExpertIndex + 1) % list.length
                : (currentExpertIndex - 1 + list.length) % list.length;

        handleSearchEmployeeClick(list[newIndex], newIndex);
    };

    const closeSearchResults = () => {
        setIsSearchResultsVisible(false);
        setSearchResultsData(null);
        setSearchSelectedEmployee(null);
        setSearchEmployeeDetail(null);
        setIsSearchEmployeeLoading(false);
        setSearchResultsError(null);
        setCurrentExpertIndex(0);
        setSearchMode(null);
        setLastSearchTerm(""); // ← add
        setInputValue("");
        setChipValue(null);
        setIsChipMode(false);
        setIsQuerySearchProductTypesExpanded(false);
        setIsQuerySearchBrandsExpanded(false);
        setIsEntitySearchProductTypesExpanded(false);
        setIsEntitySearchBrandsExpanded(false);
    };

    // ── Scroll to censme-directory-widget with responsive offset ──
    const scrollToCensmeDirectoryWidget = () => {
        let offset = 164; // default offset

        if (typeof window !== "undefined") {
            const width = window.innerWidth;
            if (width < 991) {
                offset = 98;
            } else if (width < 1079) {
                offset = 113;
            }
        }

        const element = document.querySelector(".censme-directory-widget");
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;
            window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
    };

    const handleCoworkerClick = (index: number) => {
        scrollToCensmeDirectoryWidget();
        if (selectedCoworkerIndex === index) {
            setSelectedCoworkerIndex(null);
            setCoworkerSMEDetail(null);
            setCoworkerSMEDetailError(null);
            setIsCoworkerSMEDetailLoading(false);
            return;
        }
        const coworker = coworkerList[index];
        setSelectedCoworkerIndex(index);
        if (coworker?.id) {
            fetchCoworkerDetail(coworker.id);
        } else {
            setCoworkerSMEDetail(null);
            setCoworkerSMEDetailError(null);
            setIsCoworkerSMEDetailLoading(false);
        }
    };

    const handleNewToCentroClick = (index: number) => {
        scrollToCensmeDirectoryWidget();
        if (selectedNewTocentroIndex === index) {
            setSelectedNewTocentroIndex(null);
            setNewToCentroSMEDetail(null);
            setNewToCentroSMEDetailError(null);
            setIsNewToCentroSMEDetailLoading(false);
            return;
        }
        const person = newToCentroList[index];
        setSelectedNewTocentroIndex(index);
        if (person?.id) {
            fetchNewToCentroDetail(person.id);
        } else {
            setNewToCentroSMEDetail(null);
            setNewToCentroSMEDetailError(null);
            setIsNewToCentroSMEDetailLoading(false);
        }
    };

    const handleCloseProfile = () => {
        setSelectedCoworkerIndex(null);
        setCoworkerSMEDetail(null);
        setCoworkerSMEDetailError(null);
        setIsCoworkerSMEDetailLoading(false);
    };

    const handleCloseNewToCentro = () => {
        setSelectedNewTocentroIndex(null);
        setNewToCentroSMEDetail(null);
        setNewToCentroSMEDetailError(null);
        setIsNewToCentroSMEDetailLoading(false);
    };

    const isCoworkerProfileOpen = selectedCoworkerIndex !== null;
    const isNewToCentroProfileOpen = selectedNewTocentroIndex !== null;

    // ── Effects ───────────────────────────────────────────────────────────────
    React.useEffect(() => {
        loadCentroConnectDataHandler({});
        searchCentroConnectHandler({ query: "" });
    }, []);

    React.useEffect(() => {
        if (typeof window === "undefined") return;
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (flyoutRef.current && !flyoutRef.current.contains(event.target as Node)) {
                setIsFlyoutVisible(false);
                if (!isChipMode && chipValue !== null) {
                    inputValue === editingStartValueRef.current ? setIsChipMode(true) : setChipValue(null);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isChipMode, chipValue, inputValue]);
    React.useEffect(() => {
        setIsDashboardLoading(true);
        setDashboardError(null);
        getCENSMEDashboardDetailsData({
            onSuccess: (result: CENSMEDashboardDetailsModel) => {
                setSmeDashboardData(result);
                setIsDashboardLoading(false);
            },
        });
    }, []);

    const commitChip = (value: string) => {
        setInputValue(value);
        setChipValue(value);
        setIsChipMode(true);
        setIsFlyoutVisible(false);
        editingStartValueRef.current = null;
    };

    const handleFlyoutItemClick = (item: string) => {
        commitChip(item);
    };

    const handleFlyoutPersonClick = (person: any) => {
        setIsFlyoutVisible(false);
        setIsChipMode(false);
        setInputValue("");
        setChipValue(null);
        // ── Go directly to employee detail via entity search ──
        if (person.id) {
            executeEntitySearch(person.id, "Employee");
        } else {
            executeSearch(person.name);
        }
    };

    const handleChipClick = () => {
        setIsSearchResultsVisible(false);
        setSearchResultsData(null);
        setSearchSelectedEmployee(null);
        setSearchEmployeeDetail(null);
        setIsSearchEmployeeLoading(false);
        setSearchResultsError(null);
        setCurrentExpertIndex(0);
        setSearchMode(null);
        setLastSearchTerm("");
        setInputValue("");
        setChipValue(null);
        setIsChipMode(false);
        setAutoCompleteData(null);
        setIsFlyoutVisible(true);
        setTimeout(() => inputRef.current?.focus(), 0);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);

        if (chipValue !== null && value !== editingStartValueRef.current) {
            setChipValue(null);
            editingStartValueRef.current = null;
        }

        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);

        if (value.length >= 3) {
            debounceTimerRef.current = setTimeout(() => {
                setIsFlyoutVisible(true);
                getCENSMEAutoCompleteData({
                    query: value,
                    onSuccess: (result: CENSMEAutoCompleteModel) => {
                        setAutoCompleteData(result);
                        setIsFlyoutVisible(true);
                    },
                });
            }, 300);
        } else {
            setAutoCompleteData(null);
            setIsFlyoutVisible(false);
            // ── Reset search results when input is cleared or below 3 chars ──
            if (value.length === 0) {
                setIsSearchResultsVisible(false);
                setSearchResultsData(null);
                setSearchSelectedEmployee(null);
                setSearchEmployeeDetail(null);
                setIsSearchEmployeeLoading(false);
                setSearchResultsError(null);
                setCurrentExpertIndex(0);
                setSearchMode(null);
                setLastSearchTerm("");
                setChipValue(null);
                setIsChipMode(false);
            }
        }
    };

    const handleInputFocus = () => {
        if (inputValue.length > 0) setIsFlyoutVisible(true);
    };
    const hasSMEDirectoryAccess =
        /\bSME-ADMIN\b/.test(session?.userRoles) || /\bCentro-Employee\b/.test(session?.userRoles);
    React.useEffect(() => {
        if (!hasSMEDirectoryAccess) {
            window.location.href = "/";
        }
    }, [session]);
    if (!hasSMEDirectoryAccess) return null;

    const hasValidPhotoUrl = (url: string | null | undefined): boolean => {
        if (!url || typeof url !== "string") return false;
        return /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif|ico|tiff|tif|jfif)$/i.test(url);
    };

    return (
        <StyledWrapper>
            {/* ── Centro Connect Search ──────────────────────────────────── */}
            <StyledWrapper {...styles.mainContainer}>
                <StyledWrapper {...styles.headingContainer}>
                    <Typography as="h1" {...styles.header}>
                        {translate("Centro Connect")}
                    </Typography>
                    <Hidden below="md">
                        <Typography {...styles.textAreaStyles}>
                            {translate(
                                "Discover expertise across Centro and connect with teammates who can help move your customer forward.",
                            )}
                        </Typography>
                    </Hidden>
                </StyledWrapper>
                <StyledWrapper {...styles.searchWrapper} ref={flyoutRef}>
                    {isChipMode ? (
                        <StyledWrapper {...styles.chipInputWrapper}>
                            <StyledWrapper {...styles.chipBadge}>
                                {chipValue}

                                <StyledWrapper onClick={handleChipClick}>
                                    <CloseIcon />
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper
                                css={css`
                                    position: absolute;
                                    right: 20px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    width: 24px;
                                    height: 24px;
                                    cursor: pointer;
                                `}
                                onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    const trimmed = (chipValue ?? "").trim();
                                    if (trimmed.length >= 3) executeSearch(trimmed);
                                }}
                            >
                                {/* <SearchIcon /> */}
                                <Icon
                                    src={SearchIcon}
                                    style={{
                                        width: "24px !important",
                                        height: "24px !important",
                                        top: "6px !important",
                                    }}
                                    {...styles.searchIconStyle}
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    ) : (
                        <TextField
                            {...styles.searchInput}
                            placeholder={
                                isMobile
                                    ? "Search by product type, brand, or br..."
                                    : translate("Search by product type, brand, branch or people")
                            }
                            autoComplete="on"
                            clickableText={translate("submit search")}
                            data-test-selector="headerSearchInputTextField"
                            className="search-input"
                            value={inputValue}
                            ref={inputRef}
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                const trimmed = inputValue.trim();
                                if (e.key === "Enter" && trimmed.length >= 3) {
                                    commitChip(trimmed);
                                    executeSearch(trimmed);
                                    setIsFlyoutVisible(false);
                                }
                            }}
                            iconClickableProps={{
                                onClick: () => {
                                    const trimmed = inputValue.trim();
                                    if (trimmed.length >= 3) {
                                        commitChip(trimmed);
                                        executeSearch(trimmed);
                                        setIsFlyoutVisible(false);
                                    }
                                },
                            }}
                        />
                    )}

                    {/* ── Flyout ─────────────────────────────────────────── */}
                    {isFlyoutVisible && autoCompleteData && (
                        <StyledWrapper {...styles.flyoutContainer}>
                            <StyledWrapper {...styles.flyoutScrollBody}>
                                {autoCompleteData.productAutoComplete.length > 0 && (
                                    <StyledWrapper {...styles.flyoutSectionBlock}>
                                        <StyledWrapper {...styles.flyoutSectionHeading}>
                                            <Typography {...styles.flyoutSectionLabelText}>
                                                {translate("Product Categories")}
                                            </Typography>
                                            <Typography {...styles.flyoutSectionSubtitle}>
                                                {translate("Find SMEs by Product Category")}
                                            </Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.flyoutSectionGrid}>
                                            {autoCompleteData.productAutoComplete.map((item: any, idx: number) => (
                                                <Typography
                                                    key={idx}
                                                    as="a"
                                                    {...styles.flyoutSectionLink}
                                                    onClick={() => {
                                                        commitChip(item.name ?? item);
                                                        if (item.id)
                                                            executeEntitySearch(
                                                                item.id,
                                                                "ProductType",
                                                                item.name ?? item,
                                                            );
                                                    }}
                                                >
                                                    {translate(item.name ?? item)}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {autoCompleteData.brandAutoComplete.length > 0 && (
                                    <StyledWrapper {...styles.flyoutSectionBlock}>
                                        <StyledWrapper {...styles.flyoutSectionHeading}>
                                            <Typography {...styles.flyoutSectionLabelText}>
                                                {translate("Brands")}
                                            </Typography>
                                            <Typography {...styles.flyoutSectionSubtitle}>
                                                {translate("Find SMEs by Brand")}
                                            </Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.flyoutSectionGrid}>
                                            {autoCompleteData.brandAutoComplete.map((item: any, idx: number) => (
                                                <Typography
                                                    key={idx}
                                                    as="a"
                                                    {...styles.flyoutSectionLink}
                                                    onClick={() => {
                                                        commitChip(item.name ?? item);
                                                        if (item.id)
                                                            executeEntitySearch(item.id, "Brand", item.name ?? item);
                                                    }}
                                                >
                                                    {translate(item.name ?? item)}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {autoCompleteData.branchAutoComplete.length > 0 && (
                                    <StyledWrapper {...styles.flyoutSectionBlock}>
                                        <StyledWrapper {...styles.flyoutSectionHeading}>
                                            <Typography {...styles.flyoutSectionLabelText}>
                                                {translate("Branches")}
                                            </Typography>
                                            <Typography {...styles.flyoutSectionSubtitle}>
                                                {translate("Find SMEs by Branch")}
                                            </Typography>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.flyoutSectionGrid}>
                                            {autoCompleteData.branchAutoComplete.map((item: any, idx: number) => (
                                                <Typography
                                                    key={idx}
                                                    as="a"
                                                    {...styles.flyoutSectionLink}
                                                    onClick={() => {
                                                        commitChip(item.name ?? item);
                                                        if (item.id)
                                                            executeEntitySearch(item.id, "Branch", item.name ?? item);
                                                    }}
                                                >
                                                    {translate(item.name ?? item)}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {autoCompleteData.employeeAutoComplete.length > 0 && (
                                    <StyledWrapper {...styles.flyoutPeopleSection}>
                                        <Typography {...styles.flyoutSectionLabel}>{translate("People")}</Typography>
                                        {autoCompleteData.employeeAutoComplete.map(
                                            (person: SMEEmployeeAutoComplete, personIndex: number) => (
                                                <React.Fragment key={personIndex}>
                                                    {personIndex > 0 && (
                                                        <StyledWrapper {...styles.flyoutPeopleDivider} />
                                                    )}
                                                    <StyledWrapper
                                                        {...styles.flyoutPersonRow}
                                                        onClick={() => handleFlyoutPersonClick(person)}
                                                    >
                                                        <StyledWrapper {...styles.flyoutPersonLeft}>
                                                            <StyledWrapper {...styles.flyoutPersonAvatar}>
                                                                {person?.photoUrl &&
                                                                hasValidPhotoUrl(person?.photoUrl) ? (
                                                                    <Img src={`${origin}${person.photoUrl}`} />
                                                                ) : (
                                                                    <AvatarPlaceholder size={40} />
                                                                )}
                                                            </StyledWrapper>
                                                            <StyledWrapper {...styles.flyoutPersonInfo}>
                                                                <Typography {...styles.flyoutPersonName}>
                                                                    {person.name}
                                                                </Typography>
                                                                <StyledWrapper {...styles.flyoutPersonMeta}>
                                                                    <Typography {...styles.flyoutPersonTitle}>
                                                                        {person.title}
                                                                    </Typography>
                                                                </StyledWrapper>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                        <Typography as="div" {...styles.flyoutPersonExpertise}>
                                                            {person.expertise}
                                                        </Typography>
                                                    </StyledWrapper>
                                                </React.Fragment>
                                            ),
                                        )}
                                    </StyledWrapper>
                                )}

                                {inputValue.length > 0 && (
                                    <StyledWrapper {...styles.flyoutFooter}>
                                        <Typography
                                            as="a"
                                            {...styles.flyoutFooterLink}
                                            onClick={() => {
                                                const trimmed = inputValue.trim();
                                                if (trimmed) {
                                                    commitChip(trimmed);
                                                    executeSearch(trimmed);
                                                }
                                            }}
                                        >
                                            {`${translate("View all results for")} '${inputValue}' →`}
                                        </Typography>
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </StyledWrapper>
            <div className="censme-directory-widget"></div>
            {/* ── Search Results Page ───────────────────────────────────────── */}
            {isSearchResultsVisible && (
                <StyledWrapper style={{ maxWidth: 1800, margin: "0 auto" }}>
                    {isSpotlightSearch && (
                        <StyledWrapper
                            {...styles.closeBtnWrapeSpotlight}
                            onClick={() => {
                                setIsSearchResultsVisible(false);
                                setSearchResultsData(null);
                                setSearchSelectedEmployee(null);
                                setSearchEmployeeDetail(null);
                                setIsSearchEmployeeLoading(false);
                                setSearchResultsError(null);
                                setCurrentExpertIndex(0);
                                setSearchMode(null);
                                setLastSearchTerm("");
                                setIsSpotlightSearch(false);
                            }}
                        >
                            <Typography
                                style={{
                                    color: "#0F96D9",
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    display: "flex",
                                    gap: 5,
                                }}
                            >
                                <span>
                                    <ArrowLeftIconSME />
                                </span>
                                {`Back to ${lastSearchTerm?.trim() ?? ""} expert `}
                            </Typography>
                        </StyledWrapper>
                    )}
                    {/* ── Back button ── */}
                    {/* <StyledWrapper
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            marginBottom: 32,
                            cursor: "pointer",
                            padding: "48px 64px 0",
                        }}
                        onClick={
                            searchSelectedEmployee && isEntitySearch
                                ? () => {
                                      setSearchSelectedEmployee(null);
                                      setSearchEmployeeDetail(null);
                                      setCurrentExpertIndex(0);
                                  }
                                : closeSearchResults
                        }
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0072ce" strokeWidth="2">
                            <path d="M19 12H5M12 5l-7 7 7 7" />
                        </svg>
                        <Typography style={{ color: "#0072ce", fontSize: 14, fontWeight: 600 }}>
                            {searchSelectedEmployee && isEntitySearch
                                ? translate("Back to Experts")
                                : translate("Back")}
                        </Typography>
                    </StyledWrapper> */}

                    {/* ── Loading ── */}
                    {isSearchResultsLoading && (
                        <StyledWrapper
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "80px 0",
                                gap: 12,
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#9aa3b0"
                                strokeWidth="2"
                                strokeLinecap="round"
                                style={{ animation: "spin 1s linear infinite" }}
                            >
                                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                            </svg>
                            <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
                            <Typography style={{ color: "#9aa3b0", fontSize: 14 }}>
                                {translate("Searching…")}
                            </Typography>
                        </StyledWrapper>
                    )}

                    {/* ── Error ── */}
                    {searchResultsError && !isSearchResultsLoading && (
                        <StyledWrapper style={{ color: "#dc2626", fontSize: 14, padding: "32px 64px" }}>
                            {searchResultsError}
                        </StyledWrapper>
                    )}

                    {/* ── ENTITY SEARCH: Expert list ── */}
                    {!isSearchResultsLoading && !searchSelectedEmployee && isEntitySearch && searchResultsData && (
                        <StyledWrapper {...styles.expertResultsWrapper}>
                            {/* Heading */}
                            <Typography style={{ fontSize: 32, fontWeight: 700, color: "#312828", marginBottom: 8 }}>
                                {lastSearchTerm && lastSearchTerm.trim()
                                    ? entityExpertList.length === 1
                                        ? `${lastSearchTerm} Expert`
                                        : `${lastSearchTerm} Experts`
                                    : translate("Experts")}
                            </Typography>
                            {lastSearchTerm && lastSearchTerm.trim() && (
                                <Typography style={{ fontSize: 16, color: "#262525", marginBottom: 32 }}>
                                    {`Browse ${lastSearchTerm} expertise and the teams supporting them.`}
                                </Typography>
                            )}

                            {entityExpertList.length === 0 ? (
                                <StyledWrapper
                                    style={{ padding: "64px 0", textAlign: "center", color: "#9aa3b0", fontSize: 14 }}
                                >
                                    {translate("No experts found.")}
                                </StyledWrapper>
                            ) : (
                                /* Expert cards grid */
                                <StyledWrapper
                                    // key={i}
                                    style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}
                                >
                                    {entityExpertList.map((emp, i) => (
                                        <StyledWrapper
                                            key={i}
                                            onClick={() => handleSearchEmployeeClick(emp, i)}
                                            {...styles.coworkerDivNewSection}
                                            onMouseEnter={(e: any) => {
                                                e.currentTarget.style.borderColor = "#0F96D9";
                                                e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,114,206,0.1)";
                                            }}
                                            onMouseLeave={(e: any) => {
                                                e.currentTarget.style.borderColor = "#e0dfe0";
                                                e.currentTarget.style.boxShadow = "none";
                                            }}
                                        >
                                            <StyledWrapper style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                                {emp?.photoUrl && hasValidPhotoUrl(emp?.photoUrl) ? (
                                                    <Img
                                                        src={emp?.photoUrl}
                                                        style={{
                                                            width: 56,
                                                            height: 56,
                                                            borderRadius: "50%",
                                                            border: "2px solid #bdbbbd",
                                                            objectFit: "cover",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                ) : (
                                                    <AvatarPlaceholder size={56} />
                                                )}

                                                <StyledWrapper style={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography
                                                        style={{
                                                            fontSize: 16,
                                                            fontWeight: 600,
                                                            color: "#262525",
                                                            lineHeight: "24px",
                                                        }}
                                                    >
                                                        {emp.fullName ?? emp.name}
                                                    </Typography>
                                                    <Typography
                                                        style={{
                                                            fontSize: 16,
                                                            color: "#262525",
                                                            lineHeight: "20px",
                                                        }}
                                                    >
                                                        {emp.title}
                                                    </Typography>
                                                    <Typography
                                                        style={{
                                                            fontSize: 16,
                                                            color: "#262525",
                                                            lineHeight: "20px",
                                                        }}
                                                    >
                                                        {emp.branchName}
                                                    </Typography>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.tagsWrapper}>
                                                {emp.isTechnicalSupport && (
                                                    <StyledWrapper {...styles.technicalIcon}>
                                                        <TechnicalIcon></TechnicalIcon> {translate("Technical Support")}
                                                    </StyledWrapper>
                                                )}

                                                {emp.isPriceAndAvailability && (
                                                    <StyledWrapper {...styles.priceTagIcon}>
                                                        <PriceTagIcon /> {translate("Price & Availability")}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                            {emp.bioSnippet && (
                                                <Typography
                                                    style={{
                                                        fontSize: 16,
                                                        color: "#262525",
                                                        lineHeight: "24px",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    {emp.bioSnippet}
                                                </Typography>
                                            )}
                                        </StyledWrapper>
                                    ))}
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}

                    {/* ── ENTITY SEARCH: Expert profile with prev/next navigation ── */}
                    {!isSearchResultsLoading && searchSelectedEmployee && isEntitySearch && (
                        <StyledWrapper {...styles.expertProfileWrapper}>
                            {isSearchEmployeeLoading ? (
                                <StyledWrapper
                                    style={{ padding: "60px", textAlign: "center", color: "#9aa3b0", fontSize: 14 }}
                                >
                                    {translate("Loading profile…")}
                                </StyledWrapper>
                            ) : (
                                <>
                                    {/* ── Back button — shown only when NOT from spotlight ── */}
                                    {!isSpotlightSearch && (
                                        <StyledWrapper
                                            {...styles.backBtnWrapper}
                                            onClick={() => {
                                                setSearchSelectedEmployee(null);
                                                setSearchEmployeeDetail(null);
                                                setIsSearchEmployeeLoading(false);
                                                setCurrentExpertIndex(0);
                                            }}
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#0F96D9"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            >
                                                <path d="M19 12H5M12 5l-7 7 7 7" />
                                            </svg>
                                            <Typography style={{ color: "#0F96D9", fontSize: 14, fontWeight: 600 }}>
                                                {translate("Back to Experts")}
                                            </Typography>
                                        </StyledWrapper>
                                    )}

                                    {/* ── Close button — shown only when from spotlight ── */}
                                    {/* {isSpotlightSearch && (
                                        <StyledWrapper
                                            {...styles.backBtnWrapper}
                                            onClick={() => {
                                                setIsSearchResultsVisible(false);
                                                setSearchResultsData(null);
                                                setSearchSelectedEmployee(null);
                                                setSearchEmployeeDetail(null);
                                                setIsSearchEmployeeLoading(false);
                                                setSearchResultsError(null);
                                                setCurrentExpertIndex(0);
                                                setSearchMode(null);
                                                setLastSearchTerm("");
                                                setIsSpotlightSearch(false);
                                            }}
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#0F96D9"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            >
                                                <path d="M18 6L6 18M6 6l12 12" />
                                            </svg>
                                            <Typography style={{ color: "#0F96D9", fontSize: 14, fontWeight: 600 }}>
                                                {translate("Close")}
                                            </Typography>
                                        </StyledWrapper>
                                    )} */}
                                    <StyledWrapper {...styles.expertProfileHeader}>
                                        <StyledWrapper {...styles.expertProfileInfo}>
                                            <StyledWrapper {...styles.expertProfileAvatar}>
                                                {searchEmployeeDetail?.photoUrl &&
                                                hasValidPhotoUrl(searchEmployeeDetail?.photoUrl) ? (
                                                    <Img
                                                        src={searchEmployeeDetail?.photoUrl}
                                                        style={{
                                                            width: 56,
                                                            height: 56,
                                                            borderRadius: "50%",
                                                            border: "2px solid #bdbbbd",
                                                            objectFit: "cover",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                ) : (
                                                    <AvatarPlaceholder size={56} />
                                                )}
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.expertProfileInfoWrapper}>
                                                {entityExpertList.length > 1 && (
                                                    <Hidden above="sm">
                                                        {" "}
                                                        {/* shows only on mobile/tablet */}
                                                        <StyledWrapper
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 6,
                                                                cursor: "pointer",
                                                                marginBottom: 2,
                                                            }}
                                                            onClick={() => handleNavigateExpert("next")}
                                                        >
                                                            <Typography
                                                                style={{
                                                                    fontSize: 13,
                                                                    fontWeight: 600,
                                                                    color: "#0F96D9",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {`Next ${lastSearchTerm?.trim() ?? ""} expert →`}
                                                            </Typography>
                                                        </StyledWrapper>
                                                    </Hidden>
                                                )}
                                                <Typography {...styles.expertProfileName}>
                                                    {searchEmployeeDetail?.name ??
                                                        searchSelectedEmployee.fullName ??
                                                        searchSelectedEmployee.name}
                                                </Typography>
                                                <Typography {...styles.expertProfileMeta}>
                                                    {`${searchEmployeeDetail?.title ?? searchSelectedEmployee.title} | ${searchEmployeeDetail?.branchName ?? searchSelectedEmployee.branchName}`}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.expertProfileActionsWithLink}>
                                            {/* ── Next Expert link ── */}
                                            {entityExpertList.length > 1 && (
                                                <Hidden below="md" style={{ alignSelf: "flex-end" }}>
                                                    {" "}
                                                    {/* shows only on desktop */}
                                                    <StyledWrapper
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 6,
                                                            cursor: "pointer",
                                                            justifyContent: "flex-end",
                                                        }}
                                                        onClick={() => handleNavigateExpert("next")}
                                                    >
                                                        <Typography
                                                            style={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: "#0F96D9",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {`Next ${lastSearchTerm?.trim() ?? ""} expert →`}
                                                        </Typography>
                                                    </StyledWrapper>
                                                </Hidden>
                                            )}
                                            <StyledWrapper {...styles.buttonsWrapper}>
                                                <Hidden below="md">
                                                    <Clickable
                                                        {...styles.phoneClickAble}
                                                        href={`tel:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`}
                                                    >
                                                        <Icon src={Phone} {...styles.phoneIconStyles} />
                                                        <Typography as="span" {...styles.phoneNoStyles}>
                                                            {searchEmployeeDetail?.phone ??
                                                                searchSelectedEmployee.phone}
                                                        </Typography>
                                                    </Clickable>
                                                </Hidden>
                                                <Hidden above="sm">
                                                    <Clickable
                                                        href={`tel:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`}
                                                    >
                                                        <Button {...styles.expertProfileEmailBtn} variant="primary">
                                                            {translate("Call")}
                                                        </Button>
                                                    </Clickable>
                                                </Hidden>
                                                {searchEmployeeDetail?.isTextMessageAllowed && (
                                                    <Hidden above="sm">
                                                        <Button
                                                            {...styles.expertProfileEmailBtn}
                                                            variant="secondary"
                                                            onClick={() => {
                                                                window.location.href = `sms:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`;
                                                            }}
                                                        >
                                                            {translate("Text")}
                                                        </Button>
                                                    </Hidden>
                                                )}

                                                <Clickable
                                                    href={`mailto:${searchEmployeeDetail?.email ?? searchSelectedEmployee.email}`}
                                                >
                                                    <Button {...styles.expertProfileEmailBtn} variant="secondary">
                                                        {translate("Email")}
                                                    </Button>
                                                </Clickable>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>

                                    {/* ── Areas of Expertise ── */}
                                    {(() => {
                                        const detail = searchEmployeeDetail;
                                        if (!detail) return null;

                                        const hasProducts = (detail.productTypesExpertise?.length ?? 0) > 0;
                                        const hasBrands = (detail.brandsExpertise?.length ?? 0) > 0;
                                        if (!hasProducts && !hasBrands) return null;

                                        return (
                                            <StyledWrapper {...styles.expertProfileSectionAbout}>
                                                <Typography {...styles.expertProfileSectionTitle}>
                                                    {translate("Areas of Expertise")}
                                                </Typography>

                                                {hasProducts && (
                                                    <StyledWrapper>
                                                        <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                                            {translate("Product Categories")}
                                                        </Typography>
                                                        <StyledWrapper
                                                            style={{ display: "flex", flexDirection: "column", gap: 6 }}
                                                        >
                                                            {(detail.productTypesExpertise ?? [])
                                                                .slice(
                                                                    0,
                                                                    isEntitySearchProductTypesExpanded ? undefined : 10,
                                                                )
                                                                .map((area, idx) => (
                                                                    <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                                        {/* Name */}
                                                                        <Typography {...styles.expertProfileBodyText}>
                                                                            {area.name}
                                                                        </Typography>

                                                                        {/* Tags */}
                                                                        {(area.isTechnicalSupport ||
                                                                            area.isPriceAndAvailability) && (
                                                                            <StyledWrapper
                                                                                {...styles.tagsWrapperCustom}
                                                                            >
                                                                                {area.isTechnicalSupport && (
                                                                                    <StyledWrapper
                                                                                        {...styles.technicalIcon}
                                                                                    >
                                                                                        <TechnicalIcon />{" "}
                                                                                        {translate("Technical Support")}
                                                                                    </StyledWrapper>
                                                                                )}

                                                                                {area.isPriceAndAvailability && (
                                                                                    <StyledWrapper
                                                                                        {...styles.priceTagIcon}
                                                                                    >
                                                                                        <PriceTagIcon />{" "}
                                                                                        {translate(
                                                                                            "Price & Availability",
                                                                                        )}
                                                                                    </StyledWrapper>
                                                                                )}
                                                                            </StyledWrapper>
                                                                        )}
                                                                    </StyledWrapper>
                                                                ))}
                                                        </StyledWrapper>
                                                        {(detail.productTypesExpertise?.length ?? 0) > 10 && (
                                                            <Button
                                                                variant="secondary"
                                                                onClick={() =>
                                                                    setIsEntitySearchProductTypesExpanded(
                                                                        !isEntitySearchProductTypesExpanded,
                                                                    )
                                                                }
                                                                style={{ marginTop: 12, alignSelf: "flex-start" }}
                                                            >
                                                                {isEntitySearchProductTypesExpanded
                                                                    ? translate("Show Less")
                                                                    : translate("Show More")}
                                                            </Button>
                                                        )}
                                                    </StyledWrapper>
                                                )}

                                                {hasBrands && (
                                                    <StyledWrapper>
                                                        <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                                            {translate("Brands")}
                                                        </Typography>
                                                        <StyledWrapper
                                                            style={{ display: "flex", flexDirection: "column", gap: 6 }}
                                                        >
                                                            {(detail.brandsExpertise ?? [])
                                                                .slice(0, isEntitySearchBrandsExpanded ? undefined : 10)
                                                                .map((brand, idx) => (
                                                                    <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                                        {/* Name */}
                                                                        <Typography {...styles.expertProfileBodyText}>
                                                                            {brand.name}
                                                                        </Typography>

                                                                        {/* Tags */}
                                                                        {(brand.isTechnicalSupport ||
                                                                            brand.isPriceAndAvailability) && (
                                                                            <StyledWrapper
                                                                                {...styles.tagsWrapperCustom}
                                                                                as="span"
                                                                            >
                                                                                {brand.isTechnicalSupport && (
                                                                                    <StyledWrapper
                                                                                        {...styles.technicalIcon}
                                                                                    >
                                                                                        <TechnicalIcon />{" "}
                                                                                        {translate("Technical Support")}
                                                                                    </StyledWrapper>
                                                                                )}

                                                                                {brand.isPriceAndAvailability && (
                                                                                    <StyledWrapper
                                                                                        {...styles.priceTagIcon}
                                                                                    >
                                                                                        <PriceTagIcon />{" "}
                                                                                        {translate(
                                                                                            "Price & Availability",
                                                                                        )}
                                                                                    </StyledWrapper>
                                                                                )}
                                                                            </StyledWrapper>
                                                                        )}
                                                                    </StyledWrapper>
                                                                ))}
                                                        </StyledWrapper>
                                                        {(detail.brandsExpertise?.length ?? 0) > 10 && (
                                                            <Button
                                                                variant="secondary"
                                                                onClick={() =>
                                                                    setIsEntitySearchBrandsExpanded(
                                                                        !isEntitySearchBrandsExpanded,
                                                                    )
                                                                }
                                                                style={{ marginTop: 12, alignSelf: "flex-start" }}
                                                            >
                                                                {isEntitySearchBrandsExpanded
                                                                    ? translate("Show Less")
                                                                    : translate("Show More")}
                                                            </Button>
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        );
                                    })()}

                                    <StyledWrapper {...styles.expertProfileSectionAbout}>
                                        <Typography {...styles.expertProfileSectionTitle}>
                                            {translate("About")}
                                        </Typography>
                                        <Typography {...styles.expertProfileBodyText}>
                                            {searchEmployeeDetail?.bioFull ?? searchSelectedEmployee.bioSnippet ?? ""}
                                        </Typography>
                                    </StyledWrapper>

                                    {(searchEmployeeDetail?.education || searchEmployeeDetail?.trainingsAttended) && (
                                        <StyledWrapper {...styles.expertProfileSectionTraining}>
                                            <Typography {...styles.expertProfileSectionTitle}>
                                                {translate("Training and Background")}
                                            </Typography>
                                            {searchEmployeeDetail.education && (
                                                <StyledWrapper {...styles.expertProfileTrainingItem}>
                                                    <Typography {...styles.expertProfileTrainingInstitution}>
                                                        {translate("Education")}
                                                    </Typography>
                                                    <Typography {...styles.expertProfileTrainingDegree}>
                                                        {searchEmployeeDetail.education}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                            {searchEmployeeDetail.trainingsAttended && (
                                                <StyledWrapper {...styles.expertProfileTrainingItem}>
                                                    <Typography {...styles.expertProfileTrainingInstitution}>
                                                        {translate("Trainings Attended")}
                                                    </Typography>
                                                    <Typography {...styles.expertProfileTrainingDegree}>
                                                        {searchEmployeeDetail.trainingsAttended}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>
                                    )}

                                    {/* ── More Experts section (replaces prev/next nav) ── */}
                                    {entityExpertList.length > 1 && (
                                        <StyledWrapper {...styles.expertProfileSectionAbout}>
                                            <Typography {...styles.expertProfileSectionTitle}>
                                                {`More ${lastSearchTerm && lastSearchTerm.trim() ? lastSearchTerm : ""} Experts`}
                                            </Typography>
                                            <StyledWrapper
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "24px",
                                                    marginTop: 16,
                                                }}
                                            >
                                                {entityExpertList
                                                    .filter((_, idx) => idx !== currentExpertIndex)
                                                    .map((emp, i) => {
                                                        const originalIndex = entityExpertList.findIndex(
                                                            e => e.id === emp.id,
                                                        );
                                                        return (
                                                            <StyledWrapper
                                                                key={i}
                                                                onClick={() =>
                                                                    handleSearchEmployeeClick(emp, originalIndex)
                                                                }
                                                                {...styles.coworkerDivNewSection}
                                                                onMouseEnter={(e: any) => {
                                                                    e.currentTarget.style.borderColor = "#0F96D9";
                                                                    e.currentTarget.style.boxShadow =
                                                                        "0 2px 12px rgba(0,114,206,0.1)";
                                                                }}
                                                                onMouseLeave={(e: any) => {
                                                                    e.currentTarget.style.borderColor = "#e0dfe0";
                                                                    e.currentTarget.style.boxShadow = "none";
                                                                }}
                                                            >
                                                                <StyledWrapper
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 12,
                                                                    }}
                                                                >
                                                                    {emp?.photoUrl &&
                                                                    hasValidPhotoUrl(emp?.photoUrl) ? (
                                                                        <Img
                                                                            src={emp?.photoUrl}
                                                                            style={{
                                                                                width: 56,
                                                                                height: 56,
                                                                                borderRadius: "50%",
                                                                                border: "2px solid #bdbbbd",
                                                                                objectFit: "cover",
                                                                                flexShrink: 0,
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AvatarPlaceholder size={56} />
                                                                    )}
                                                                    <StyledWrapper
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: 16,
                                                                                fontWeight: 600,
                                                                                color: "#262525",
                                                                                lineHeight: "24px",
                                                                            }}
                                                                        >
                                                                            {emp.fullName ?? emp.name}
                                                                        </Typography>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: 16,
                                                                                color: "#262525",
                                                                                lineHeight: "20px",
                                                                            }}
                                                                        >
                                                                            {emp.title}
                                                                        </Typography>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: 16,
                                                                                color: "#262525",
                                                                                lineHeight: "20px",
                                                                            }}
                                                                        >
                                                                            {emp.branchName}
                                                                        </Typography>
                                                                    </StyledWrapper>
                                                                </StyledWrapper>
                                                                {emp.bioSnippet && (
                                                                    <Typography
                                                                        style={{
                                                                            fontSize: 16,
                                                                            color: "#262525",
                                                                            lineHeight: "24px",
                                                                            display: "-webkit-box",
                                                                            WebkitLineClamp: 2,
                                                                            WebkitBoxOrient: "vertical",
                                                                            overflow: "hidden",
                                                                        }}
                                                                    >
                                                                        {emp.bioSnippet}
                                                                    </Typography>
                                                                )}
                                                            </StyledWrapper>
                                                        );
                                                    })}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    )}
                                </>
                            )}
                        </StyledWrapper>
                    )}

                    {/* ── QUERY SEARCH: Employee Detail View ── */}
                    {!isSearchResultsLoading && searchSelectedEmployee && searchMode === "query" && (
                        <StyledWrapper>
                            {isSearchEmployeeLoading ? (
                                <StyledWrapper
                                    style={{ padding: "60px", textAlign: "center", color: "#9aa3b0", fontSize: 14 }}
                                >
                                    {translate("Loading profile…")}
                                </StyledWrapper>
                            ) : (
                                <StyledWrapper {...styles.expertProfileWrapper}>
                                    <StyledWrapper
                                        {...styles.backBtnWrapper}
                                        onClick={() => {
                                            if (searchResultsData) {
                                                setSearchSelectedEmployee(null);
                                                setSearchEmployeeDetail(null);
                                                setIsSearchEmployeeLoading(false);
                                                setCurrentExpertIndex(0);
                                            } else {
                                                closeSearchResults();
                                            }
                                        }}
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0F96D9"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        >
                                            <path d="M19 12H5M12 5l-7 7 7 7" />
                                        </svg>
                                        <Typography style={{ color: "#0F96D9", fontSize: 14, fontWeight: 600 }}>
                                            {translate("Back")}
                                        </Typography>
                                    </StyledWrapper>

                                    <StyledWrapper {...styles.expertProfileHeader}>
                                        <StyledWrapper {...styles.expertProfileInfo}>
                                            <StyledWrapper {...styles.expertProfileAvatar}>
                                                {searchEmployeeDetail?.photoUrl &&
                                                hasValidPhotoUrl(searchEmployeeDetail?.photoUrl) ? (
                                                    <Img src={searchEmployeeDetail?.photoUrl} />
                                                ) : (
                                                    <AvatarPlaceholder size={56} />
                                                )}
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.expertProfileInfoWrapper}>
                                                <Typography {...styles.expertProfileName}>
                                                    {searchEmployeeDetail?.name ??
                                                        searchSelectedEmployee.fullName ??
                                                        searchSelectedEmployee.name}
                                                </Typography>
                                                <Typography {...styles.expertProfileMeta}>
                                                    {`${searchEmployeeDetail?.title ?? searchSelectedEmployee.title} | ${searchEmployeeDetail?.branchName ?? searchSelectedEmployee.branchName}`}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.expertProfileActions}>
                                            <Hidden below="md">
                                                <Clickable
                                                    {...styles.phoneClickAble}
                                                    href={`tel:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`}
                                                >
                                                    <Icon src={Phone} {...styles.phoneIconStyles} />
                                                    <Typography as="span" {...styles.phoneNoStyles}>
                                                        {searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}
                                                    </Typography>
                                                </Clickable>
                                            </Hidden>
                                            <Hidden above="sm">
                                                <Clickable
                                                    href={`tel:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`}
                                                >
                                                    <Button {...styles.expertProfileEmailBtn} variant="primary">
                                                        {translate("Call")}
                                                    </Button>
                                                </Clickable>
                                            </Hidden>
                                            {searchEmployeeDetail?.isTextMessageAllowed && (
                                                <Hidden above="sm">
                                                    <Button
                                                        {...styles.expertProfileEmailBtn}
                                                        variant="secondary"
                                                        onClick={() => {
                                                            window.location.href = `sms:${searchEmployeeDetail?.phone ?? searchSelectedEmployee.phone}`;
                                                        }}
                                                    >
                                                        {translate("Text")}
                                                    </Button>
                                                </Hidden>
                                            )}

                                            <Clickable
                                                href={`mailto:${searchEmployeeDetail?.email ?? searchSelectedEmployee.email}`}
                                            >
                                                <Button {...styles.expertProfileEmailBtn} variant="secondary">
                                                    {translate("Email")}
                                                </Button>
                                            </Clickable>
                                        </StyledWrapper>
                                    </StyledWrapper>

                                    {(() => {
                                        const detail = searchEmployeeDetail;
                                        if (!detail) return null;

                                        const hasProducts = (detail.productTypesExpertise?.length ?? 0) > 0;
                                        const hasBrands = (detail.brandsExpertise?.length ?? 0) > 0;
                                        if (!hasProducts && !hasBrands) return null;

                                        return (
                                            <StyledWrapper {...styles.expertProfileSectionAbout}>
                                                <Typography {...styles.expertProfileSectionTitle}>
                                                    {translate("Areas of Expertise")}
                                                </Typography>

                                                {hasProducts && (
                                                    <StyledWrapper>
                                                        <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                                            {translate("Product Categories")}
                                                        </Typography>
                                                        <StyledWrapper
                                                            style={{ display: "flex", flexDirection: "column", gap: 6 }}
                                                        >
                                                            {(detail.productTypesExpertise ?? [])
                                                                .slice(
                                                                    0,
                                                                    isQuerySearchProductTypesExpanded ? undefined : 10,
                                                                )
                                                                .map((area, idx) => (
                                                                    <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                                        {/* Name */}
                                                                        <Typography {...styles.expertProfileBodyText}>
                                                                            {area.name}
                                                                        </Typography>

                                                                        {/* Tags */}
                                                                        {(area.isTechnicalSupport ||
                                                                            area.isPriceAndAvailability) && (
                                                                            <StyledWrapper
                                                                                {...styles.tagsWrapperCustom}
                                                                            >
                                                                                {area.isTechnicalSupport && (
                                                                                    <StyledWrapper
                                                                                        {...styles.technicalIcon}
                                                                                    >
                                                                                        <TechnicalIcon />{" "}
                                                                                        {translate("Technical Support")}
                                                                                    </StyledWrapper>
                                                                                )}

                                                                                {area.isPriceAndAvailability && (
                                                                                    <StyledWrapper
                                                                                        {...styles.priceTagIcon}
                                                                                    >
                                                                                        <PriceTagIcon />{" "}
                                                                                        {translate(
                                                                                            "Price & Availability",
                                                                                        )}
                                                                                    </StyledWrapper>
                                                                                )}
                                                                            </StyledWrapper>
                                                                        )}
                                                                    </StyledWrapper>
                                                                ))}
                                                        </StyledWrapper>
                                                        {(detail.productTypesExpertise?.length ?? 0) > 10 && (
                                                            <Button
                                                                variant="secondary"
                                                                onClick={() =>
                                                                    setIsQuerySearchProductTypesExpanded(
                                                                        !isQuerySearchProductTypesExpanded,
                                                                    )
                                                                }
                                                                style={{ marginTop: 12, alignSelf: "flex-start" }}
                                                            >
                                                                {isQuerySearchProductTypesExpanded
                                                                    ? translate("Show Less")
                                                                    : translate("Show More")}
                                                            </Button>
                                                        )}
                                                    </StyledWrapper>
                                                )}

                                                {hasBrands && (
                                                    <StyledWrapper>
                                                        <Typography {...styles.expertProfileSectionTitleForExpertise}>
                                                            {translate("Brands")}
                                                        </Typography>
                                                        <StyledWrapper
                                                            style={{ display: "flex", flexDirection: "column", gap: 6 }}
                                                        >
                                                            {(detail.brandsExpertise ?? [])
                                                                .slice(0, isQuerySearchBrandsExpanded ? undefined : 10)
                                                                .map((area, idx) => (
                                                                    <StyledWrapper key={idx} {...styles.wrapExperties}>
                                                                        {/* Name */}
                                                                        <Typography {...styles.expertProfileBodyText}>
                                                                            {area.name}
                                                                        </Typography>

                                                                        {/* Tags */}
                                                                        {(area.isTechnicalSupport ||
                                                                            area.isPriceAndAvailability) && (
                                                                            <StyledWrapper
                                                                                {...styles.tagsWrapperCustom}
                                                                            >
                                                                                {area.isTechnicalSupport && (
                                                                                    <StyledWrapper
                                                                                        {...styles.technicalIcon}
                                                                                    >
                                                                                        <TechnicalIcon />{" "}
                                                                                        {translate("Technical Support")}
                                                                                    </StyledWrapper>
                                                                                )}

                                                                                {area.isPriceAndAvailability && (
                                                                                    <StyledWrapper
                                                                                        {...styles.priceTagIcon}
                                                                                    >
                                                                                        <PriceTagIcon />{" "}
                                                                                        {translate(
                                                                                            "Price & Availability",
                                                                                        )}
                                                                                    </StyledWrapper>
                                                                                )}
                                                                            </StyledWrapper>
                                                                        )}
                                                                    </StyledWrapper>
                                                                ))}
                                                        </StyledWrapper>
                                                        {(detail.brandsExpertise?.length ?? 0) > 10 && (
                                                            <Button
                                                                variant="secondary"
                                                                onClick={() =>
                                                                    setIsQuerySearchBrandsExpanded(
                                                                        !isQuerySearchBrandsExpanded,
                                                                    )
                                                                }
                                                                style={{ marginTop: 12, alignSelf: "flex-start" }}
                                                            >
                                                                {isQuerySearchBrandsExpanded
                                                                    ? translate("Show Less")
                                                                    : translate("Show More")}
                                                            </Button>
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        );
                                    })()}

                                    <StyledWrapper {...styles.expertProfileSectionAbout}>
                                        <Typography {...styles.expertProfileSectionTitle}>
                                            {translate("About")}
                                        </Typography>
                                        <Typography {...styles.expertProfileBodyText}>
                                            {searchEmployeeDetail?.bioFull ?? searchSelectedEmployee.bioSnippet ?? ""}
                                        </Typography>
                                    </StyledWrapper>

                                    {(searchEmployeeDetail?.education || searchEmployeeDetail?.trainingsAttended) && (
                                        <StyledWrapper {...styles.expertProfileSectionTraining}>
                                            <Typography {...styles.expertProfileSectionTitle}>
                                                {translate("Training and Background")}
                                            </Typography>
                                            {searchEmployeeDetail?.education && (
                                                <StyledWrapper {...styles.expertProfileTrainingItem}>
                                                    <Typography {...styles.expertProfileTrainingInstitution}>
                                                        {translate("Education")}
                                                    </Typography>
                                                    <Typography {...styles.expertProfileTrainingDegree}>
                                                        {searchEmployeeDetail.education}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                            {searchEmployeeDetail?.trainingsAttended && (
                                                <StyledWrapper {...styles.expertProfileTrainingItem}>
                                                    <Typography {...styles.expertProfileTrainingInstitution}>
                                                        {translate("Trainings Attended")}
                                                    </Typography>
                                                    <Typography {...styles.expertProfileTrainingDegree}>
                                                        {searchEmployeeDetail.trainingsAttended}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}

                    {/* ── QUERY SEARCH: Results list ── */}
                    {!isSearchResultsLoading &&
                        !searchSelectedEmployee &&
                        searchMode === "query" &&
                        searchResultsData && (
                            <StyledWrapper {...styles.resultForGeneric}>
                                <Typography {...styles.resultsForWrapper}>
                                    {lastSearchTerm && lastSearchTerm.trim()
                                        ? `Results for '${lastSearchTerm}'`
                                        : translate("Search Results")}
                                </Typography>

                                {/* ── Product Categories ── */}
                                {(searchResultsData.productSearchList?.length ?? 0) > 0 && (
                                    <StyledWrapper {...styles.resultHeadingWrapper}>
                                        <Typography {...styles.resultSubHeadingText}>
                                            {translate("Categories")}
                                        </Typography>
                                        <StyledWrapper style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                            {searchResultsData.productSearchList!.map((cat, i) => (
                                                <Typography
                                                    key={i}
                                                    as="a"
                                                    {...styles.resultValues}
                                                    onClick={() => executeEntitySearch(cat.id, "ProductType", cat.name)}
                                                >
                                                    {cat.name}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {/* ── Brands ── */}
                                {(searchResultsData.brandSearchList?.length ?? 0) > 0 && (
                                    <StyledWrapper {...styles.resultHeadingWrapper}>
                                        <Typography {...styles.resultSubHeadingText}>{translate("Brands")}</Typography>
                                        <StyledWrapper style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                            {searchResultsData.brandSearchList!.map((brand, i) => (
                                                <Typography
                                                    key={i}
                                                    as="a"
                                                    {...styles.resultValues}
                                                    onClick={() => executeEntitySearch(brand.id, "Brand", brand.name)}
                                                >
                                                    {brand.name}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {/* ── Branches ── */}
                                {(searchResultsData.branchSearchList?.length ?? 0) > 0 && (
                                    <StyledWrapper {...styles.resultHeadingWrapper}>
                                        <Typography {...styles.resultSubHeadingText}>
                                            {translate("Branches")}
                                        </Typography>
                                        <StyledWrapper style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                            {searchResultsData.branchSearchList!.map((branch, i) => (
                                                <Typography
                                                    key={i}
                                                    as="a"
                                                    {...styles.resultValues}
                                                    onClick={() =>
                                                        executeEntitySearch(branch.id, "Branch", branch.name)
                                                    }
                                                >
                                                    {branch.name}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {/* ── People ── */}
                                {(searchResultsData.employeeSearchList?.length ?? 0) > 0 && (
                                    <StyledWrapper {...styles.resultHeadingWrapperPeople}>
                                        <Typography {...styles.resultSubHeadingText}>{translate("Peoples")}</Typography>
                                        <StyledWrapper style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
                                            {searchResultsData.employeeSearchList!.map((emp, i) => (
                                                <StyledWrapper
                                                    key={i}
                                                    onClick={() => handleSearchEmployeeClick(emp, i)}
                                                    {...styles.coworkerDiv}
                                                    onMouseEnter={(e: any) => {
                                                        e.currentTarget.style.borderColor = "#BDBBBD";
                                                        e.currentTarget.style.boxShadow =
                                                            "0 2px 12px rgba(0,114,206,0.1)";
                                                    }}
                                                    onMouseLeave={(e: any) => {
                                                        e.currentTarget.style.borderColor = "#e0dfe0";
                                                        e.currentTarget.style.boxShadow = "none";
                                                    }}
                                                >
                                                    <StyledWrapper {...styles.detailDiv}>
                                                        <StyledWrapper {...styles.coworkerAvatar}>
                                                            {emp?.photoUrl && hasValidPhotoUrl(emp?.photoUrl) ? (
                                                                <Img src={emp?.photoUrl} />
                                                            ) : (
                                                                <AvatarPlaceholder size={56} />
                                                            )}
                                                        </StyledWrapper>
                                                        <StyledWrapper {...styles.detailsTextDiv}>
                                                            <Typography {...styles.nameText}>
                                                                {emp.fullName ?? emp.name}
                                                            </Typography>
                                                            <StyledWrapper {...styles.titleBranchDiv}>
                                                                <Typography {...styles.titleText}>
                                                                    {emp.title}
                                                                </Typography>
                                                                <Typography {...styles.branchText}>
                                                                    {emp.branchName}
                                                                </Typography>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                    {(emp.isTechnicalSupport || emp.isPriceAndAvailability) && (
                                                        <StyledWrapper {...styles.tagsWrapperCustom} as="span">
                                                            {emp.isTechnicalSupport && (
                                                                <StyledWrapper {...styles.technicalIcon}>
                                                                    <TechnicalIcon /> {translate("Technical Support")}
                                                                </StyledWrapper>
                                                            )}

                                                            {emp.isPriceAndAvailability && (
                                                                <StyledWrapper {...styles.priceTagIcon}>
                                                                    <PriceTagIcon /> {translate("Price & Availability")}
                                                                </StyledWrapper>
                                                            )}
                                                        </StyledWrapper>
                                                    )}
                                                    {emp.bioSnippet && (
                                                        <StyledWrapper {...styles.snippetText}>
                                                            {emp.bioSnippet}
                                                        </StyledWrapper>
                                                    )}
                                                </StyledWrapper>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                {/* ── No results ── */}
                                {(searchResultsData.employeeSearchList?.length ?? 0) === 0 &&
                                    (searchResultsData.brandSearchList?.length ?? 0) === 0 &&
                                    (searchResultsData.branchSearchList?.length ?? 0) === 0 &&
                                    (searchResultsData.productSearchList?.length ?? 0) === 0 && (
                                        <StyledWrapper
                                            style={{
                                                padding: "64px 0",
                                                textAlign: "center",
                                                color: "#9aa3b0",
                                                fontSize: 14,
                                            }}
                                        >
                                            {translate("No results found.")}
                                        </StyledWrapper>
                                    )}
                            </StyledWrapper>
                        )}
                </StyledWrapper>
            )}
            {!isSearchResultsVisible && isCoworkerProfileOpen && (
                <ExpertProfileView
                    apiDetail={coworkerSMEDetail}
                    isLoading={isCoworkerSMEDetailLoading}
                    error={coworkerSMEDetailError}
                    onClose={handleCloseProfile}
                    showAreasOfExpertise={true}
                />
            )}

            {!isSearchResultsVisible && !isNewToCentroProfileOpen && (
                <StyledWrapper {...styles.mainContainerCo}>
                    <StyledWrapper {...styles.headingContainerCo}>
                        <Typography as="h2" {...styles.headerCo}>
                            {translate("Meet Your Coworkers")}
                        </Typography>
                        <Typography {...styles.textAreaStylesCo}>
                            {translate("Get to know more of your teammates across Centro.")}
                        </Typography>
                    </StyledWrapper>

                    {/* Loading */}
                    {isDashboardLoading && <SectionSpinner />}

                    {!isDashboardLoading && dashboardError && (
                        <SectionEmpty message={translate("Could not load coworkers. Please try again later.")} />
                    )}

                    {!isDashboardLoading && !dashboardError && coworkerList.length > 0 && (
                        <StyledWrapper {...styles.coworkerContainer}>
                            {coworkerList.map((coworker: any, i: number) => (
                                <StyledWrapper
                                    key={i}
                                    {...(selectedCoworkerIndex === i ? styles.coworkerDivActive : styles.coworkerDiv)}
                                    onClick={() => handleCoworkerClick(i)}
                                >
                                    <StyledWrapper {...styles.detailDiv}>
                                        <StyledWrapper {...styles.coworkerAvatar}>
                                            {coworker?.photoUrl && hasValidPhotoUrl(coworker?.photoUrl) ? (
                                                <Img src={coworker?.photoUrl} />
                                            ) : (
                                                <AvatarPlaceholder size={56} />
                                            )}
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.detailsTextDiv}>
                                            <Typography {...styles.nameText}>
                                                {translate(coworker.fullName ?? coworker.name)}
                                            </Typography>
                                            <StyledWrapper {...styles.titleBranchDiv}>
                                                <Typography {...styles.titleText}>
                                                    {translate(coworker.title)}
                                                </Typography>
                                                <Typography {...styles.branchText}>
                                                    {translate(coworker.branchName ?? coworker.branch)}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    {/* <StyledWrapper {...styles.tagsWrapper}>
                                        {
                                            <StyledWrapper {...styles.technicalIcon}>
                                                <TechnicalIcon></TechnicalIcon> {translate("Technical Support")}
                                            </StyledWrapper>
                                        }

                                        {
                                            <StyledWrapper {...styles.priceTagIcon}>
                                                <PriceTagIcon /> {translate("Price & Availability")}
                                            </StyledWrapper>
                                        }
                                    </StyledWrapper> */}
                                    <StyledWrapper {...styles.snippetText}>
                                        {translate(coworker.bioSnippet ?? coworker.snippet)}
                                    </StyledWrapper>
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    )}

                    {/* Empty */}
                    {!isDashboardLoading && !dashboardError && coworkerList.length === 0 && (
                        <SectionEmpty message={translate("No coworkers to display.")} />
                    )}
                </StyledWrapper>
            )}
            {!isSearchResultsVisible && isNewToCentroProfileOpen && (
                <ExpertProfileView
                    apiDetail={newToCentroSMEDetail}
                    isLoading={isNewToCentroSMEDetailLoading}
                    error={newToCentroSMEDetailError}
                    onClose={handleCloseNewToCentro}
                    showAreasOfExpertise={true}
                />
            )}

            {!isSearchResultsVisible && !isCoworkerProfileOpen && (
                <StyledWrapper {...styles.mainContainerNewSection}>
                    <StyledWrapper {...styles.headingContainerNewSection}>
                        <Typography as="h2" {...styles.headerNewSection}>
                            {translate("New to Centro")}
                        </Typography>
                        <Typography {...styles.textAreaStylesNewSection}>
                            {translate("Get to know more of your teammates across Centro.")}
                        </Typography>
                    </StyledWrapper>

                    {/* Loading */}
                    {isDashboardLoading && <SectionSpinner />}

                    {/* Error */}
                    {!isDashboardLoading && dashboardError && (
                        <SectionEmpty message={translate("Could not load new employees. Please try again later.")} />
                    )}

                    {/* Cards */}
                    {!isDashboardLoading && !dashboardError && newToCentroList.length > 0 && (
                        <StyledWrapper {...styles.coworkerContainer}>
                            {newToCentroList.map((person: any, i: number) => (
                                <StyledWrapper
                                    key={i}
                                    {...(selectedNewTocentroIndex === i
                                        ? styles.coworkerDivActive
                                        : styles.coworkerDivNewSection)}
                                    onClick={() => handleNewToCentroClick(i)}
                                >
                                    <StyledWrapper {...styles.detailDivNewSection}>
                                        <StyledWrapper {...styles.coworkerAvatarBorder}>
                                            {person?.photoUrl && hasValidPhotoUrl(person?.photoUrl) ? (
                                                <Img
                                                    src={person?.photoUrl}
                                                    style={{
                                                        width: "56px",
                                                        height: "56px",
                                                        borderRadius: "50%",
                                                    }}
                                                    {...styles.newSectionExpertImage}
                                                />
                                            ) : (
                                                <AvatarPlaceholder size={56} />
                                            )}
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.detailsTextDivNewSection}>
                                            <Typography {...styles.nameTextNewSection}>
                                                {translate(person.fullName ?? person.name)}
                                            </Typography>
                                            <StyledWrapper {...styles.titleBranchDivNewSection}>
                                                <Typography {...styles.titleTextNewSection}>
                                                    {translate(person.title)}
                                                </Typography>
                                                <Typography {...styles.branchTextNewSection}>
                                                    {translate(person.branchName ?? person.branch)}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    )}

                    {/* Empty */}
                    {!isDashboardLoading && !dashboardError && newToCentroList.length === 0 && (
                        <SectionEmpty message={translate("No new employees to display.")} />
                    )}
                </StyledWrapper>
            )}
            {(!isSearchResultsVisible || isSpotlightSearch) && !isCoworkerProfileOpen && !isNewToCentroProfileOpen && (
                <StyledWrapper {...styles.mainContainerEx}>
                    <StyledWrapper {...styles.headingContainerEx}>
                        <Typography as="h3" {...styles.headerEx}>
                            {translate("Find Experts by Category")}
                        </Typography>
                        <Typography {...styles.textAreaStylesEx}>
                            {translate("Browse expertise areas and the teams supporting them.")}
                        </Typography>
                    </StyledWrapper>

                    {/* Loading */}
                    {isDashboardLoading && <SectionSpinner />}

                    {/* Error */}
                    {!isDashboardLoading && dashboardError && (
                        <SectionEmpty
                            message={translate("Could not load expertise spotlight. Please try again later.")}
                        />
                    )}

                    {/* Cards */}
                    {!isDashboardLoading && !dashboardError && expertiseSpotlightList.length > 0 && (
                        <StyledWrapper {...styles.cardsContainer} style={{ alignItems: "stretch" }}>
                            {expertiseSpotlightList.map((card: any, i: number) => {
                                const cardLabel = card.expertiseName ?? card.label ?? "";
                                const smeAvatars: any[] = (card.smeDetails ?? []).slice(0, 3);
                                const expertCount = (card.smeDetails ?? []).length;
                                const entityId = card.expertiseId ?? card.id ?? "";
                                const entityType = card.source ?? card.source ?? "";
                                const brandPlaceholder =
                                    "https://assets-02d248ee59.cdn.insitecloud.net/ec8faad8f17d2ac_md.webp";
                                const hasValidImageUrl =
                                    card.imageUrl && hasValidPhotoUrl(card.imageUrl) ? card.imageUrl : brandPlaceholder;
                                return (
                                    <StyledWrapper
                                        key={i}
                                        {...styles.cardStyle}
                                        style={{ display: "flex", flexDirection: "column" }}
                                    >
                                        <StyledWrapper
                                            {...styles.cardImage}
                                            style={{ height: 164, overflow: "hidden", flexShrink: 0 }}
                                        >
                                            <Img
                                                src={hasValidImageUrl}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    display: "block",
                                                }}
                                            />
                                        </StyledWrapper>
                                        <StyledWrapper
                                            {...styles.categoryWrapper}
                                            style={{
                                                flex: 1,
                                                display: "flex",
                                                alignItems: "flex-start",
                                                minHeight: 80,
                                            }}
                                        >
                                            <StyledWrapper
                                                style={{
                                                    display: "flex",
                                                    // alignItems: "center",
                                                    justifyContent: "space-between",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                    gap: "8px",
                                                }}
                                            >
                                                <StyledWrapper
                                                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                                                >
                                                    <Typography {...styles.categoryText}>
                                                        {translate(cardLabel)}
                                                    </Typography>
                                                    {expertCount > 0 && entityId && (
                                                        <Typography
                                                            as="a"
                                                            style={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: "#0F96D9",
                                                                cursor: "pointer",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                            onClick={(e: React.MouseEvent) => {
                                                                e.stopPropagation();
                                                                scrollToCensmeDirectoryWidget();
                                                                executeEntitySearch(
                                                                    entityId,
                                                                    entityType,
                                                                    cardLabel,
                                                                    true,
                                                                );
                                                            }}
                                                        >
                                                            {`${expertCount} ${expertCount === 1 ? translate("expert") : translate("experts")} →`}
                                                        </Typography>
                                                    )}
                                                </StyledWrapper>
                                                {smeAvatars.length > 0 && (
                                                    <StyledWrapper {...styles.expertsImagesWrapper}>
                                                        {smeAvatars.map((sme: any, j: number) => (
                                                            <StyledWrapper key={j} {...styles.expertAvatarSmall}>
                                                                {sme.photoUrl && hasValidPhotoUrl(sme.photoUrl) ? (
                                                                    <Img src={sme.photoUrl} />
                                                                ) : (
                                                                    <AvatarPlaceholder size={56} />
                                                                )}
                                                            </StyledWrapper>
                                                        ))}
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                );
                            })}
                        </StyledWrapper>
                    )}

                    {/* Empty */}
                    {!isDashboardLoading && !dashboardError && expertiseSpotlightList.length === 0 && (
                        <SectionEmpty message={translate("No expertise areas to display.")} />
                    )}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CENSMEDirectoryWidget),
    definition: {
        group: "Basic",
    },
};

export default widgetModule;
